import {
    APP_TITLE,
    LANDING_BRIEF,
    LANDING_LANGUAGE_SELECTOR,
    LANDING_COUNTRY_SELECTOR,
    LANDING_TERMS,
    LANDING_TERMS_ERROR,
    LANDING_CAPTCHA_ERROR,
    BUTTON_PREV,
    BUTTON_NEXT,
    BUTTON_SUBMIT,
    MENU_FEEDBACK_FORM,
    MENU_FEEDBACK_STATUS,
    MENU_FORM_INTAKE,
    MENU_FORM_EVENT_DETAILS,
    MENU_FORM_PRODUCT_INFO,
    SYSTEM_FEEDBACK_FORM,
    SYSTEM_FEEDBACK_STATUS,
    FORM_TITLE,
    FORM_MANDATORY_FIELDS,
    APP_DESCRIPTION,
    SUBMIT_FEEDBACK,
    CHECK_SUBMITTED_FEEDBACK,
    BTN_LAUNCH_FORM,
    BTN_CHECK_STATUS,
    SELECT_RESPONSE,
    FUNCTION_ROLE,
    CUSTOMER_ACCOUNT_NUMBER,
    ENTER_CUSTOMER_ACCOUNT,
    HELP_CUSTOMER_ACCOUNT_NUMBER,
    EVENT_REPORTED,
    REFERENCE_NUMBER,
    ENTER_REFERENCE,
    WHO_REPORTED_TO,
    WHO_WAS_NOTIFIED,
    ENTER_NAME,
    PRODUCT_SURVEILLANCE,
    YOUR_NAME,
    OCCUPATION,
    PHONE_NUMBER,
    ENTER_PHONE_NUMBER,
    ENTER_EMAIL,
    EMAIL_ADDRESS,
    ENTER_ADDRESS,
    ENTER_NA_IF_UNKNOWN,
    FACILITY_HOSPITAL,
    ENTER_FACILITY,
    ADDRESS_1,
    ADDRESS_2,
    CITY,
    STATE,
    POSTAL_CODE,
    COUNTRY,
    END_USER_CUSTOMER,
    ADDITIONAL_CONTACT_PERSON,
    ADDITIONAL_PHONE,
    ADDITIONAL_EMAIL,
    ANOTHER_FACILITY_ADDRESS,
    ANOTHER_FACILITY_HOSPITAL,
    ANOTHER_ENTER_FACILITY,
    ANOTHER_ADDRESS_1,
    ANOTHER_ADDRESS_2,
    ANOTHER_CITY,
    ANOTHER_STATE,
    ANOTHER_POSTAL_CODE,
    ANOTHER_COUNTRY,
    LOT_SERIAL_NUMBER,
    ENTER_LOT_SERIAL_NUMBER,
    HELP_LOT_SERIAL_NUMBER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
    PRODUCT_CODE,
    ENTER_PRODUCT_CODE,
    HELP_PRODUCT_CODE,
    NDC,
    ENTER_NDC,
    UDI,
    ENTER_UDI,
    PRODUCT_NAME,
    ENTER_PRODUCT_NAME,
    HELP_PRODUCT_NAME,
    BEST_DESCRIBES,
    QUANTITY_TO_SELECT,
    ENTER_QUANTITY,
    HELP_QUANTITY,
    UNIT,
    AVAILABLE_TO_RETURNED,
    PHOTOGRAPH_AVAILABLE,
    HELP_PHOTOGRAPH_AVAILABLE,
    UPLOAD_IMAGES,
    REPORTER_NAME,
    REPORTER_FACILITY,
    REPORTER_OCCUPATION,
    ENTER_NUMBER,
    REPORTER_PHONE_NUMBER,
    REPORTER_EMAIL_ADDRESS,
    EMPLOYEE_NAME,
    EMPLOYEE_PHONE_NUMBER,
    EMPLOYEE_EMAIL_ADDRESS,
    RETURNING_FOR_INVESTIGATION,
    HELP_RETURNING_FOR_INVESTIGATION,
    UNUSED_BAXTER_PRODUCT,
    YOU_INDICATED_SAMPLES,
    SAMPLE_RETURN_KIT,
    A_BOX_WITH_A_PREPAID_LABEL,
    SAME_AS_MY_ADDRESS,
    OTHER_CONTACT_NAME,
    OTHER_CONTACT_OCCUPATION,
    OTHER_CONTACT_PHONE_NUMBER,
    OTHER_CONTACT_EMAIL_ADDRESS,
    MANUFACTURED_BY_ANOTHER_COMPANY,
    CUSTOMER_EXPLICITLY_REQUEST,
    EXPLICITLY_REQUEST_CREDIT,
    PRODUCT_FROM_BAXTER,
    QUANTITY_REQUESTED_CREDIT,
    ENTER_OCCUPATION,
    LOT_QUANTITY_NUMBER,
    WHOLESALERS_NAME,
    PLACE_WHOLESALERS_NAME,
    DATE_OF_EVENT,
    DATE_OF_EVENT_MSG,
    HELP_DATE_OF_EVENT,
    DATE_BAXTER_EMPLOYEE,
    DATE_MESSAGE_BAXTER_EMPLOYEE,
    DURING_WHAT_PROCESS,
    WAS_THE_PATIENT,
    WERE_YOU_CONNECTED,
    PROVIDE_ANY_ADDITIONAL,
    HELP_YOU_IDENTIFIED_MORE,
    ENTER_DETAILS,
    PROVIDE_ANY_ATTACHMENT,
    WAS_NEGATIVE_MEDICAL,
    WAS_MEDICAL_INTERVENTION,
    PROVIDE_DETAILS,
    REQUIRED_TREATMENT,
    ENTER_TREATMENT,
    RELEVANT_TESTS,
    HELP_RELEVANT_TESTS,
    RELEVANT_MEDICAL_HISTORY,
    ENTER_HISTORY,
    PATIENT_NAME,
    PATIENT_INITIALS,
    PATIENT_PHONE_NUMBER,
    PATIENT_EMAIL_ADDRESS,
    I_DO_NOT_WISH_TO_PROVIDE,
    PATIENT_ADDRESS,
    SAME_ADDRESS,
    DRUG_BEING_USED,
    PATIENT_IDENTIFIER,
    PATIENT_AGE_OR_DOB,
    ENTER_PATIENT_AGE,
    PATIENT_GENDER,
    PATIENT_WEIGHT,
    ENTER_WEIGHT,
    PATIENT_WEIGHT_UNIT,
    MY_NAME,
    ENTER_IN_YOUR_CONTACT,
    MY_PHONE_NUMBER,
    MY_EMAIL_ADDRESS,
    MY_ADDRESS,
    NAME_OF_BAXTER_DRUG,
    ENTER_DRUG_NAME,
    PLEASE_PROVIDE_THE_NAME,
    APPLY_TO_EACH_UNIT,
    SELECT_THE_COMPONENT,
    USE_THE_DIAGRAM,
    TYPE_OF_DAMAGE,
    PLEASE_ENTER_VALUE,
    WAS_THE_PRODUCT_KINKED,
    WERE_ANY_CLEANING,
    WHAT_WAS_THE_DISINFECTANT,
    NOTE_BAXTER_LABELING,
    SELECT_ALL_THAT_APPLY,
    DID_FOLLOWING_OCCUR,
    SELECT_THE_LOCATION,
    WAS_THE_PRODUCT_EXPOSED,
    HOW_LONG_TRANSFER,
    WAS_THERE_DIFFICULTY,
    WAS_DEVICE_OR_TOOL,
    DESCRIBE_HOW_PRODUCT,
    DID_YOU_OBSERVE,
    WERE_DIFFICULTIES_PUTTING,
    WAS_THE_TRANSFER,
    SELECT_TYPE_OF_FLOW,
    WAS_ANYTHING_BLOCKING,
    WAS_ANY_ALARM,
    SELECT_BEST_DESCRIBE,
    WERE_THE_MINICAPS,
    WAS_THE_SPONGE_VISIBLE,
    WHERE_PARTICULATE_MATTERFOREIGN,
    DESCRIBE_THE_EXACT_LOCATION,
    WAS_THE_PARTICULATE_MATTER,
    DOES_THE_PARTICULATE_MATER,
    WHAT_COMPONENT_DOES,
    SELECT_CONNECTION_ISSUE,
    WERE_ASSIST_DEVICES,
    WERE_ANY_DIFFICULTIES,
    PROVIDE_PRODUCT_INFORMATION,
    WERE_THE_SPIKE_LUER,
    BAXTER_LABELING_STATES,
    WERE_PETS_OR_ANIMALS,
    BAXTER_LABELING_CONTAMINATION,
    WERE_OTHER_ISSUES,
    WAS_MINICAP_TWISTED,
    WERE_DIFFICULTIES_TRANSFER_SET,
    DID_TRANSFER_SET_CONNECTORS,
    WHAT_WAS_THE_ALARM,
    WHERE_OBSERVED_DAMAGE,
    SELECT_THE_TYPE_OBSERVED,
    DID_DAMAGE_CAUSE_LEAK,
    WAS_THE_SHIPPING_CARTON,
    SELECT_FLOW_ISSUE_OBSERVED,
    HOW_LONG_WAS_STORAGE,
    WAS_THERE_AN_ADAPTER,
    NAME_AND_MODEL,
    NAME_VAPORIZER,
    WAS_VIAL_INVERTED,
    WHAT_VIAL_USED,
    DRUG_NAME_MANUFACTURER,
    WERE_BREAK_FRANGIBLE,
    WAS_ALARM_ASSOCIATED,
    WHAT_PART_DISCOLORED,
    DESCRIBE_DISCOLORATION,
    HOW_PRODUCT_STORED,
    DOES_DISCOLORATION_APPEAR,
    WHICH_CHAMBER_DISCOLORED,
    WAS_PEEL_SEAL_INTERCHAMBER,
    WAS_DISCOLORATION_NOTICED,
    SELECT_SPECIFICALLY_DESCRIBES,
    WHAT_DEVICE_HAD_ALARM,
    WHAT_MISSING_MISASSEMBLED,
    RECONSTITUTION_ISSUE,
    WHAT_MEDICATION_SOLUTION,
    WHAT_VOLUME_MEDICATION,
    WHAT_DEVICES_RECONSTITUTION,
    WAS_PRODUCT_EXPOSED_HEAT,
    DESCRIBE_EXPOSURE,
    WHAT_USED_ACTIVATE_SOLUTION,
    WAS_DAMAGE_OBSERVED,
    DESCRIBE_THE_DAMAGE,
    APPROXIMATELY_SOLUTION_POWDER,
    WAS_LEAK_OBSERVED,
    WHAT_FEATUR_DIFFICULT_USE,
    HOW_WAS_DIFFICULT_USE,
    WHERE_MATTER_FOREIGN,
    DOES_PARTICULATE_MATTER,
    DESCRIBE_EXACT_LOCATION,
    WAS_MATTER_FOREIGN,
    WHEN_MATTER_FOREIGN,
    PROVIDE_INFORMATION_MEDICATION,
    PRODUCT_NAME_CODE_NUMBER,
    DESCRIBE_SPIKING,
    INCLUDE_NEEDLE,
    WHAT_ADMINISTRATION_RECONSTITUTION,
    INCLUDE_MANUFACTURER,
    WAS_MEDICATION_ADDITIVE,
    WHAT_MEDICATION_ADDITIVE,
    WHAT_STATE_OF_PRODUCT,
    AFTER_UNITS_SAT,
    DID_ATTEMPT_AGITATE,
    DID_PRECIPITATE_DISSOLVE,
    WHAT_STORAGE_TEMPERATURE,
    PROVIDE_TEMPERATURE_LOCATION,
    ARE_TEMPERATURE_LOGS,
    LOGS_CAN_BE_ATTACHED,
    IS_THE_STORAGE_UNIT,
    HOW_PRODUCT_THAWED,
    WHAT_STORAGE_CONDITIONS,
    WAS_ANY_DAMAGE,
    MORE_SPECIFIC_INFORMATION,
    WHAT_PURPOSE_INDICATION,
    WHAT_ROUTE_ADMINISTRATION,
    WHAT_DATE_ADMINISTRATION,
    WHAT_DOSAGE_STRENGTH,
    WAS_RECENT_PRESCRIPTION,
    WHAT_WAS_STORAGE_TEMPERATURE,
    WERE_ANY_ADJUSTMENTS,
    SELECT_APPROPRIATE_DESCRIPTION,
    SELECT_LABELING_ISSUE,
    WAS_CONNECTION_SECURE,
    WAS_EXPIRED_PRODUCT,
    WAS_COMPONENT_DAMAGED,
    WERE_ABNORMALITIES_DAMAGE,
    WHAT_PURCHASE_ORDER_NUMBER,
    WHAT_DATE_OF_ADMINISTRATION,
    WHAT_WAS_EXPIRATION_DATE,
    DESCRIBE_WAS_INCORRECT,
    WHAT_SCANNER_USED,
    WAS_OVERPOUCH_POUCH,
    WHAT_BACKGROUND_COLOR,
    DO_ALL_OF_THE_LABELS,
    PRODUCT_INFORMATION,
    IS_A_BARCODE_SCANNER,
    HOW_ARE_THESE_PRODUCTS,
    WHAT_INFORMATION_INCORRECTLY,
    WAS_THERE_LEAK,
    WHERE_LEAK_OBSERVED,
    WAS_FRANGIBLE_OBSERVED,
    IS_MOISTURE_CLEAR,
    WHO_IS_YOUR_DISTRIBUTOR,
    WHAT_MANUFACTURER_MEDICATION,
    WHAT_GAUGE_NEEDLE,
    WHAT_ADMINISTRATION_SET,
    WAS_DIFFICULTY_SPIKING,
    WERE_FOLLOWING_SCENARIOS,
    WAS_FRANGIBLE_OBSERVED_DEFECT,
    WHAT_AMOUNT_PRESSURE,
    WAS_BAG_COMPLETELY,
    WHAT_MANUFACTURER_MODEL,
    WHAT_PRESSURE_PRIOR,
    LIST_THE_VAPORIZER,
    APPROXIMATELY_HOW_MUCH,
    WAS_THE_BOTTLE_DIFFICULT,
    WERE_VISIBLE_DEFECTS,
    SELECT_THE_OPTION,
    PROVIDE_INVOLVED_CONNECTION_ISSUE,
    WHICH_PART_SEPARATED,
    WHAT_COMPONENT_DISCOLORED,
    SELECT_DESCRIBES_DISCOLORATION,
    WAS_THE_SET_DISCOLORED,
    DID_SET_CHANGE_COLOR,
    WHAT_MEDICATION_ADDED,
    WHERE_MATERIAL_LOCATED,
    DESCRIBE_APPEARANCE_COLOR_SIZE,
    WAS_EMBEDDED_PLASTIC,
    WAS_THERE_A_PRECIPITATE,
    WHAT_MEDICATIONS_SOLUTIONS,
    WHERE_DAMAGE_COMPONENT_AFFECTED,
    WHAT_DAMAGE_ISSUE,
    DID_ISSUE_RESULT,
    WAS_PATIENT_CONNECTED,
    WAS_PRODUCT_REPLACED,
    WHICH_SITUATION_BEST,
    SELECT_MOST_LABELING_ISSUE,
    WHAT_INFORMATION_DISPLAYED,
    WHAT_SCANNER_WAS_USED,
    INCLUDE_THE_MODEL_NAME,
    WAS_PRODUCT_ORDERED,
    WHERE_LEAK_COMING,
    DID_SCENARIOS_OCCURRED_LEAK,
    WAS_POWER_INJECTOR,
    WHAT_INJECTOR_USED,
    MANUFACTURER_NAME_CODE_LOT,
    DESCRIBE_INCORRECT_INCOMPLETE,
    PROVIDE_INFORMATION_SECOND_PRODUCT,
    WHICH_COMPONENTS_WERE_FOUND,
    DESCRIBE_CUT_HOLE_SLICE,
    WAS_LEAK_ORIGINATING,
    PROVIDE_DISCONNECTION_CONNECTION,
    WHICH_SPECIFIC_BONDED,
    WERE_VISIBLE_IRREGULARITIES,
    WAS_SUCCESSFUL_CONNECTION,
    WAS_TOOL_USED_ASSIST,
    WERE_LUER_CONNECTIONS,
    WAS_PRODUCT_SECURELY,
    WHICH_DESCRIBES_FLOW_ISSUE,
    WHAT_FLOWING_BACKWARDS,
    DESCRIBE_COMPONENTS_BACKFLOW,
    DO_SITUATIONS_APPLY,
    WHICH_SPECIFIC_AREA,
    WAS_FLOW_PREVIOUSLY_SEEN,
    WAS_ANY_FOLLOWING_OBSERVED,
    WHERE_SIMULTANEOUS_FLOW,
    WHAT_TYPE_HANGER,
    WHAT_WAS_HANGER_LENGTH,
    WHICH_BAG_LOWER,
    WHAT_Y_SITE_WAS,
    WHAT_COMPONENT_WITHIN,
    WAS_COMPONENT_SET_REPLACED,
    WHAT_VOLUME_FLUID_PERIOD_TIME,
    WHAT_VOLUME_FLUID_OVER_TIME,
    WAS_USED_WITH_PUMP,
    DID_CLAMP_FAIL,
    WHAT_CLAMP_FAILED,
    WAS_ISSUES_OBSERVED_CLAMP,
    DO_OTHER_SITUATIONS_DESCRIBE,
    DESCRIBE_ALARM_OBSERVED,
    INCLUDE_ANY_MESSAGES,
    WHICH_CLAMP_HAD_ISSUE,
    WHICH_TYPE_CLAMP_ISSUE,
    SELECT_BEST_DESCRIBES_ISSUE,
    PROVIDE_MORE_DETAILS,
    PROVIDE_MORE_DETAILS_INSTRUCTIONS,
    DESCRIBE_THE_SMELL,
    WAS_ISSUES_WITH_SET,
    WHERE_LEAK_LOCATED,
    DID_OCCUR_WITH_LEAK,
    PROVIDE_INVOLVED_DISCONNECTION,
    DID_OCCURRED_WITH_THE_LEAK,
    WHERE_WAS_PRODUCT_DAMAGED,
    SELECT_ALL_APPLY,
    DESCRIBE_OBSERVED_DAMAGE,
    WHAT_COMPONENT_IS_DISCOLORED,
    DESCRIBE_HUE_TINT_SHADE,
    INSIDE_OUTSIDE_OVERPOUCH,
    DESCRIBE_EXACT_LOCATION_SIZE,
    DOES_THE_PARTICULATE_MATTER,
    WAS_PARTICULATE_MATERIAL_EMBEDDED,
    DOES_APPEAR_PRODUCT_MATERIAL,
    WHERE_DID_THE_ISSUE_OCCUR,
    LIST_COMPONENTS_IF,
    WERE_THERE_VISIBLE_IRREGULARITIES,
    SELECT_OPTION_FLOW_ISSUE,
    DESCRIBE_IRREGULARITIES,

    HOW_PRODUCT_SETUP,
    SELECT_MOST_APPROPRIATE_DESCRIPTION,
    DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
    WAS_SHIPPING_CARTON_DAMAGED,
    WHAT_PRODUCT_WAS_SUPPOSED,
    IF_PRODUCT_CODE_NOT,
    WAS_THE_CASE_MISSING,
    WHAT_CARRIER_DELIVERED,
    WHAT_IS_PURCHASE_ORDER_NUMBER,
    WHAT_QUANTITY_MISSING_UNITS,
    WAS_EXPIRED_PRODUCT_USE,
    ADD_PRODUCT_TO_THE_GRID,
    SAVE,
    CANCEL,
    ADD_MORE_PRODUCTS,
    REPORTER_ADDRESS,
    ATTACHMENTS,
    COPYRIGHT,
    TERMS_CONDITIONS,
    PRIVACY_POLICY,
    COOKIE_POLICY,
    FORM_SUB_TITLE,
    OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
    OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE,
    OPTION_FUNCTIONOPTIONS_CAREGIVER,
    OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
    OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
    OPTION_FUNCTIONOPTIONS_PATIENT,
    OPTION_FUNCTIONOPTIONS_OTHER,
    OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
    OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
    OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
    OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
    OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
    OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
    OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
    OPTION_OCCUPATIONOPTIONS_NURSE,
    OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
    OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
    OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
    OPTION_UNITOPTIONS_BOXES,
    OPTION_UNITOPTIONS_PALLETS,
    OPTION_UNITOPTIONS_UNITS,
    OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
    OPTION_PROBLEMOPTIONS_DAMAGE,
    OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
    OPTION_PROBLEMOPTIONS_DISCOLORED,
    OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
    OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
    OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
    OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
    OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
    OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
    OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
    OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
    OPTION_PATIENTSEXOPTIONS_FEMALE,
    OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
    OPTION_PATIENTSEXOPTIONS_MALE,
    OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
    OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
    OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
    OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
    OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
    OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
    OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
    OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
    OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
    OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
    OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
    OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
    OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
    OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
    OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
    OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
    OPTION_REPORTEDTOOPTIONS_BAXTER,
    OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
    OPTION_REPORTEDTOOPTIONS_EMA,
    OPTION_REPORTEDTOOPTIONS_FDA,
    OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
    OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
    OPTION_REPORTEDTOOPTIONS_TUV,
    OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
    OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
    OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
    OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
    OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
    OPTION_DAMAGEMINICAPOPTIONS_CARTON,
    OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
    OPTION_DAMAGEMINICAPOPTIONS_POUCH,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
    OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
    OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
    OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
    OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
    OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
    OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
    OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
    OPTION_BLOCKINGFLOWOPTIONS_KINK,
    OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
    OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
    OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
    OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
    OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
    OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
    OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
    OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
    OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
    OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
    OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
    OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
    OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
    OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
    OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
    OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
    OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
    OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
    OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
    OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
    OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
    OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
    OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
    OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
    OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
    OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
    OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
    OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
    OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
    OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
    OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
    OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
    OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
    OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
    OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
    OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
    OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
    OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
    OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
    OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
    OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
    OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING,
    OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
    OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
    OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
    OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
    OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
    OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
    OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
    OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
    OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
    OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
    OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
    OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
    OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
    OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
    OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
    OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
    OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
    OPTION_DESCOFISSUEOPTIONS_OTHER,
    OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
    OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
    OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
    OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
    OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
    OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
    OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
    OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
    OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
    OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
    OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
    OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
    OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
    OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
    OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
    OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
    OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
    OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
    OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
    OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
    OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
    NO_DESCRIBE_THE_COLOR,
    OPTION_LIQUIDSPILLEDOPTIONS_ML,
    OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
    OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
    OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
    OPTION_VISIBLEDEFECTSOPTIONS_CAP,
    OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
    OPTION_VISIBLEDEFECTSOPTIONS_NONE,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
    OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
    OTHER_PLEASE_SPECIFY,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
    OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
    OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
    OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
    OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
    OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
    OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
    OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
    OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
    OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
    OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
    DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
    DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
    OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
    OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
    OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER,
    OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
    OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
    OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
    OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
    OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
    OPTION_LEAKCOMINGFROMOPTIONS_CAP,
    OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
    OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
    OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
    OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
    OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
    OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
    OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
    OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
    OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
    OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
    OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
    OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
    OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
    OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
    DISCONNECTION_OF_CONNECTABLE,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
    YES_SPECIFY_THE_TOOL,
    OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
    OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
    OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
    OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
    OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
    OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
    OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
    OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
    OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
    OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
    OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
    OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER,
    OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER,
    OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
    OPTION_BAGLOWEROPTIONS_PRIMARY,
    OPTION_BAGLOWEROPTIONS_SECONDARY,
    OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
    OPTION_YSITECONNECTEDOPTIONS_LOWER,
    OPTION_YSITECONNECTEDOPTIONS_UPPER,
    OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
    OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
    OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
    OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
    OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
    OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
    OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
    OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
    OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
    OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
    OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
    OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
    OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
    OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
    OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
    OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
    OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
    OPTION_LEAKOCCUROPTIONS_OTHER,
    OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
    OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
    OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
    OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
    OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
    OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
    OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
    OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
    OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
    OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
    OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
    OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
    OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
    OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
    OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
    OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
    OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
    OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
    OPTION_ALARMOPTIONS_YES_SPECIFY,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
    OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
    OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
    OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
    OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
    OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
    OPTION_COMPONENTHADISSUEOPTIONS_LINES,
    OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
    OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
    OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
    OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
    OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
    OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
    OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
    OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
    OPTION_MONTHOPTIONS_JAN,
    OPTION_MONTHOPTIONS_FEB,
    OPTION_MONTHOPTIONS_MAR,
    OPTION_MONTHOPTIONS_APR,
    OPTION_MONTHOPTIONS_MAY,
    OPTION_MONTHOPTIONS_JUN,
    OPTION_MONTHOPTIONS_JUL,
    OPTION_MONTHOPTIONS_AUG,
    OPTION_MONTHOPTIONS_SEP,
    OPTION_MONTHOPTIONS_OCT,
    OPTION_MONTHOPTIONS_NOV,
    OPTION_MONTHOPTIONS_DEC,
    OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
    OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
    OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
    OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
    OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
    OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
    OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
    OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
    OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
    OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
    OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
    OPTION_PROBLEMOPTIONS_OTHER,
    OPTION_REPORTEDTOOPTIONS_OTHER,
    OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
    OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
    OPTION_BLOCKINGFLOWOPTIONS_OTHER,
    OPTION_DESCRIBEISSUEOPTIONS_OTHER,
    OPTION_MATERIALLOCATEDOPTIONS_OTHER,
    OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
    OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
    OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
    OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
    OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
    OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
    OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
    OPTION_LABELINGISSUEOPTIONS_OTHER,
    OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
    OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
    OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
    OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
    OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
    OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
    OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
    OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
    OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
    OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
    OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
    OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
    OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
    OPTION_ADDANOTHERFACILITYOPTIONS_NO,
    OPTION_ADDANOTHERFACILITYOPTIONS_YES,
    OPTION_PATIENINVOLVEMENTOPTIONS_NO,
    OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
    OPTION_PATIENINVOLVEMENTOPTIONS_YES,
    OPTION_OTHERFACILITYREPORTOPTIONS_NO,
    OPTION_OTHERFACILITYREPORTOPTIONS_YES,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
    OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
    OPTION_AVAILABILITYOPTIONS_NO,
    OPTION_AVAILABILITYOPTIONS_YES,
    OPTION_MEDIAAVAILABILITYOPTIONS_NO,
    OPTION_MEDIAAVAILABILITYOPTIONS_YES,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
    OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
    OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
    OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
    OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
    OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
    OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
    OPTION_COUNTERACTIONOPTIONS_NO,
    OPTION_COUNTERACTIONOPTIONS_YES,
    OPTION_DRUGUSEDOPTIONS_NO,
    OPTION_DRUGUSEDOPTIONS_YES,
    OPTION_SHARECONTACTOPTIONS_NO,
    OPTION_SHARECONTACTOPTIONS_YES,
    OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
    OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
    OPTION_DIRECTORDEROPTIONS_NO,
    OPTION_DIRECTORDEROPTIONS_YES,
    OPTION_EXCESSIVEFORCEOPTIONS_NO,
    OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
    OPTION_EXCESSIVEFORCEOPTIONS_YES,
    OPTION_TWISTCLAMPOPTIONS_NO,
    OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
    OPTION_TWISTCLAMPOPTIONS_YES,
    OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
    OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
    OPTION_ENVIRONMENTOPTIONS_NO,
    OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
    OPTION_ENVIRONMENTOPTIONS_YES,
    OPTION_SPONGEVISIBLEOPTIONS_NO,
    OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
    OPTION_SPONGEVISIBLEOPTIONS_YES,
    OPTION_MATERIALEMBEDDEDOPTIONS_NO,
    OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
    OPTION_MATERIALEMBEDDEDOPTIONS_YES,
    OPTION_PIECESMATERIALOPTIONS_NO,
    OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
    OPTION_PIECESMATERIALOPTIONS_YES,
    OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
    OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
    OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
    OPTION_INITIALCONNECTIONOPTIONS_NO,
    OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
    OPTION_INITIALCONNECTIONOPTIONS_YES,
    OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
    OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
    OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
    OPTION_PETSORANIMALSOPTIONS_NO,
    OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
    OPTION_PETSORANIMALSOPTIONS_YES,
    OPTION_MINICAPTWISTEDOPTIONS_NO,
    OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
    OPTION_MINICAPTWISTEDOPTIONS_YES,
    OPTION_TRANSFERSETOPTIONS_NO,
    OPTION_TRANSFERSETOPTIONS_UNKNOWN,
    OPTION_TRANSFERSETOPTIONS_YES,
    OPTION_RESIDUETHREADSOPTIONS_NO,
    OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
    OPTION_DAMAGECAUSELEAKOPTIONS_NO,
    OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
    OPTION_DAMAGECAUSELEAKOPTIONS_YES,
    OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
    OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
    OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
    OPTION_ADAPTERDEVICEOPTIONS_NO,
    OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
    OPTION_ADAPTERDEVICEOPTIONS_YES,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
    OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
    OPTION_FORTHMOTIONOPTIONS_NO,
    OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
    OPTION_FORTHMOTIONOPTIONS_YES,
    OPTION_ALARMNOFLOWOPTIONS_NO,
    OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
    OPTION_ALARMNOFLOWOPTIONS_YES,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
    OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
    OPTION_BROKENACTIVATEDOPTIONS_NO,
    OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
    OPTION_BROKENACTIVATEDOPTIONS_YES,
    OPTION_vaporizerSightGlassOptions_NO,
    OPTION_vaporizerSightGlassOptions_UNKNOWN,
    OPTION_vaporizerSightGlassOptions_YES,
    OPTION_PRODUCTHEATOPTIONS_NO,
    OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
    OPTION_PRODUCTHEATOPTIONS_YES,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
    OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
    OPTION_LEAKOBSERVEDOPTIONS_NO,
    OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
    OPTION_LEAKOBSERVEDOPTIONS_YES,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
    OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
    OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
    OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
    OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
    OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
    OPTION_AGITATEUNITOPTIONS_NO,
    OPTION_AGITATEUNITOPTIONS_UNKNOWN,
    OPTION_AGITATEUNITOPTIONS_YES,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
    OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
    OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
    OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
    OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
    OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
    OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
    OPTION_EXPIREDPRODUCTOPTIONS_NO,
    OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
    OPTION_EXPIREDPRODUCTOPTIONS_YES,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
    OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
    OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
    OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
    OPTION_BARCODESCANNEROPTIONS_NO,
    OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
    OPTION_BARCODESCANNEROPTIONS_YES,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
    OPTION_FRANGIBLEBROKENOPTIONS_NO,
    OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
    OPTION_FRANGIBLEBROKENOPTIONS_YES,
    OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
    OPTION_MOISTURECLEAROPTIONS_YES,
    OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
    OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
    OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
    OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
    OPTION_PRESSURECUFFOPTIONS_NO,
    OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
    OPTION_PRESSURECUFFOPTIONS_YES,
    OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
    OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
    OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
    OPTION_ADDINGMEDICATIONOPTIONS_NO,
    OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
    OPTION_ADDINGMEDICATIONOPTIONS_YES,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
    OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
    OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
    OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
    OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
    OPTION_WASPOWERINJECTOROPTIONS_NO,
    OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
    OPTION_WASPOWERINJECTOROPTIONS_YES,
    OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
    OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
    OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
    OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
    OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
    OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
    OPTION_TOOLUSEDASSISTOPTIONS_NO,
    OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
    OPTION_SECUREPRIORUSEOPTIONS_NO,
    OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
    OPTION_SECUREPRIORUSEOPTIONS_YES,
    OPTION_PRIORDISCONNECTINGOPTIONS_NO,
    OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
    OPTION_PRIORDISCONNECTINGOPTIONS_YES,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
    OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
    OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
    OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
    OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
    OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
    OPTION_WITHPUMPOPTIONS_NO,
    OPTION_WITHPUMPOPTIONS_UNKNOWN,
    OPTION_CLAMPFAILOPTIONS_NO,
    OPTION_CLAMPFAILOPTIONS_UNKNOWN,
    OPTION_CLAMPFAILOPTIONS_YES,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
    OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
    OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
    OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
    OPTION_GELPACKSOPTIONS_NO,
    OPTION_GELPACKSOPTIONS_YES,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
    OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
    OPTION_ALARMOPTIONS_NO,
    OPTION_ALARMOPTIONS_UNKNOWN,
    OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
    OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
    OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
    OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
    OPTION_TRANSFERREPLACEDOPTIONS_NO,
    OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
    OPTION_TRANSFERREPLACEDOPTIONS_YES,
    OPTION_FULLYTIGHTENEDOPTIONS_NO,
    OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
    OPTION_FULLYTIGHTENEDOPTIONS_YES,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
    OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
    OPTION_ISSUERESULTLEAKOPTIONS_NO,
    OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
    OPTION_ISSUERESULTLEAKOPTIONS_YES,
    OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
    OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
    OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
    OPTION_EXPLICITLYREQUESTOPTIONS_NO,
    OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
    OPTION_EXPLICITLYREQUESTOPTIONS_YES,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
    OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
    OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
    OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
    OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
    OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
    OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
    OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
    OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
    OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
    OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
    OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
    OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
    OPTION_HANGERUSEDOPTIONS_UNKNOWN,
    OPTION_HANGERUSEDOPTIONS_NONE,
    OPTION_BAGLOWEROPTIONS_UNKNOWN,
    OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
    OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
    OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
    OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
    OPTION_WEIGHTUNITOPTIONS_POUND,
    OPTION_INFUSATESOLUTIONOPTIONS_NO,
    OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
    PLEASE_ENTER_THE_VALUE,
    PLEASE_SELECT_THE_VALUE,
    PLEASE_SELECT_THE_DATE,
    PLEASE_CHOOSE_THE_VALUE,
    OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
    OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
    OPTION_COUNTRYOPTIONS_KOSOVO,
    OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
    OPTION_COUNTRYOPTIONS_AFGHANISTAN,
    OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
    OPTION_COUNTRYOPTIONS_ALBANIA,
    OPTION_COUNTRYOPTIONS_ALGERIA,
    OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
    OPTION_COUNTRYOPTIONS_ANDORRA,
    OPTION_COUNTRYOPTIONS_ANGOLA,
    OPTION_COUNTRYOPTIONS_ANGUILLA,
    OPTION_COUNTRYOPTIONS_ANTARCTICA,
    OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
    OPTION_COUNTRYOPTIONS_ARGENTINA,
    OPTION_COUNTRYOPTIONS_ARMENIA,
    OPTION_COUNTRYOPTIONS_ARUBA,
    OPTION_COUNTRYOPTIONS_AUSTRALIA,
    OPTION_COUNTRYOPTIONS_AUSTRIA,
    OPTION_COUNTRYOPTIONS_AZERBAIJAN,
    OPTION_COUNTRYOPTIONS_BAHAMAS,
    OPTION_COUNTRYOPTIONS_BAHRAIN,
    OPTION_COUNTRYOPTIONS_BANGLADESH,
    OPTION_COUNTRYOPTIONS_BARBADOS,
    OPTION_COUNTRYOPTIONS_BELARUS,
    OPTION_COUNTRYOPTIONS_BELGIUM,
    OPTION_COUNTRYOPTIONS_BELIZE,
    OPTION_COUNTRYOPTIONS_BENIN,
    OPTION_COUNTRYOPTIONS_BERMUDA,
    OPTION_COUNTRYOPTIONS_BHUTAN,
    OPTION_COUNTRYOPTIONS_BOLIVIA,
    OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
    OPTION_COUNTRYOPTIONS_BOTSWANA,
    OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
    OPTION_COUNTRYOPTIONS_BRAZIL,
    OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
    OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
    OPTION_COUNTRYOPTIONS_BULGARIA,
    OPTION_COUNTRYOPTIONS_BURKINA_FASO,
    OPTION_COUNTRYOPTIONS_BURUNDI,
    OPTION_COUNTRYOPTIONS_CAMBODIA,
    OPTION_COUNTRYOPTIONS_CAMEROON,
    OPTION_COUNTRYOPTIONS_CANADA,
    OPTION_COUNTRYOPTIONS_CAPE_VERDE,
    OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
    OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
    OPTION_COUNTRYOPTIONS_CHAD,
    OPTION_COUNTRYOPTIONS_CHILE,
    OPTION_COUNTRYOPTIONS_CHINA,
    OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
    OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
    OPTION_COUNTRYOPTIONS_COLOMBIA,
    OPTION_COUNTRYOPTIONS_COMOROS,
    OPTION_COUNTRYOPTIONS_CONGO,
    OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
    OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
    OPTION_COUNTRYOPTIONS_COSTA_RICA,
    OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
    OPTION_COUNTRYOPTIONS_CROATIA,
    OPTION_COUNTRYOPTIONS_CUBA,
    OPTION_COUNTRYOPTIONS_CYPRUS,
    OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
    OPTION_COUNTRYOPTIONS_DENMARK,
    OPTION_COUNTRYOPTIONS_DJIBOUTI,
    OPTION_COUNTRYOPTIONS_DOMINICA,
    OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
    OPTION_COUNTRYOPTIONS_ECUADOR,
    OPTION_COUNTRYOPTIONS_EGYPT,
    OPTION_COUNTRYOPTIONS_EL_SALVADOR,
    OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
    OPTION_COUNTRYOPTIONS_ERITREA,
    OPTION_COUNTRYOPTIONS_ESTONIA,
    OPTION_COUNTRYOPTIONS_ETHIOPIA,
    OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
    OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
    OPTION_COUNTRYOPTIONS_FIJI,
    OPTION_COUNTRYOPTIONS_FINLAND,
    OPTION_COUNTRYOPTIONS_FRANCE,
    OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
    OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
    OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
    OPTION_COUNTRYOPTIONS_GABON,
    OPTION_COUNTRYOPTIONS_GAMBIA,
    OPTION_COUNTRYOPTIONS_GEORGIA,
    OPTION_COUNTRYOPTIONS_GERMANY,
    OPTION_COUNTRYOPTIONS_GHANA,
    OPTION_COUNTRYOPTIONS_GIBRALTAR,
    OPTION_COUNTRYOPTIONS_GREECE,
    OPTION_COUNTRYOPTIONS_GREENLAND,
    OPTION_COUNTRYOPTIONS_GRENADA,
    OPTION_COUNTRYOPTIONS_GUADELOUPE,
    OPTION_COUNTRYOPTIONS_GUAM,
    OPTION_COUNTRYOPTIONS_GUATEMALA,
    OPTION_COUNTRYOPTIONS_GUERNSEY,
    OPTION_COUNTRYOPTIONS_GUINEA,
    OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
    OPTION_COUNTRYOPTIONS_GUYANA,
    OPTION_COUNTRYOPTIONS_HAITI,
    OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
    OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
    OPTION_COUNTRYOPTIONS_HONDURAS,
    OPTION_COUNTRYOPTIONS_HONG_KONG,
    OPTION_COUNTRYOPTIONS_HUNGARY,
    OPTION_COUNTRYOPTIONS_ICELAND,
    OPTION_COUNTRYOPTIONS_INDIA,
    OPTION_COUNTRYOPTIONS_INDONESIA,
    OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_IRAQ,
    OPTION_COUNTRYOPTIONS_IRELAND,
    OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
    OPTION_COUNTRYOPTIONS_ISRAEL,
    OPTION_COUNTRYOPTIONS_ITALY,
    OPTION_COUNTRYOPTIONS_JAMAICA,
    OPTION_COUNTRYOPTIONS_JAPAN,
    OPTION_COUNTRYOPTIONS_JERSEY,
    OPTION_COUNTRYOPTIONS_JORDAN,
    OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
    OPTION_COUNTRYOPTIONS_KENYA,
    OPTION_COUNTRYOPTIONS_KIRIBATI,
    OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_KUWAIT,
    OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
    OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
    OPTION_COUNTRYOPTIONS_LATVIA,
    OPTION_COUNTRYOPTIONS_LEBANON,
    OPTION_COUNTRYOPTIONS_LESOTHO,
    OPTION_COUNTRYOPTIONS_LIBERIA,
    OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
    OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
    OPTION_COUNTRYOPTIONS_LITHUANIA,
    OPTION_COUNTRYOPTIONS_LUXEMBOURG,
    OPTION_COUNTRYOPTIONS_MACAO,
    OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_MADAGASCAR,
    OPTION_COUNTRYOPTIONS_MALAWI,
    OPTION_COUNTRYOPTIONS_MALAYSIA,
    OPTION_COUNTRYOPTIONS_MALDIVES,
    OPTION_COUNTRYOPTIONS_MALI,
    OPTION_COUNTRYOPTIONS_MALTA,
    OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
    OPTION_COUNTRYOPTIONS_MARTINIQUE,
    OPTION_COUNTRYOPTIONS_MAURITANIA,
    OPTION_COUNTRYOPTIONS_MAURITIUS,
    OPTION_COUNTRYOPTIONS_MAYOTTE,
    OPTION_COUNTRYOPTIONS_MEXICO,
    OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
    OPTION_COUNTRYOPTIONS_MOLDOVA,
    OPTION_COUNTRYOPTIONS_MONACO,
    OPTION_COUNTRYOPTIONS_MONGOLIA,
    OPTION_COUNTRYOPTIONS_MONTENEGRO,
    OPTION_COUNTRYOPTIONS_MONTSERRAT,
    OPTION_COUNTRYOPTIONS_MOROCCO,
    OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
    OPTION_COUNTRYOPTIONS_MYANMAR,
    OPTION_COUNTRYOPTIONS_NAMIBIA,
    OPTION_COUNTRYOPTIONS_NAURU,
    OPTION_COUNTRYOPTIONS_NEPAL,
    OPTION_COUNTRYOPTIONS_NETHERLANDS,
    OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
    OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
    OPTION_COUNTRYOPTIONS_NICARAGUA,
    OPTION_COUNTRYOPTIONS_NIGER,
    OPTION_COUNTRYOPTIONS_NIGERIA,
    OPTION_COUNTRYOPTIONS_NIUE,
    OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
    OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
    OPTION_COUNTRYOPTIONS_NORWAY,
    OPTION_COUNTRYOPTIONS_OMAN,
    OPTION_COUNTRYOPTIONS_PAKISTAN,
    OPTION_COUNTRYOPTIONS_PALAU,
    OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
    OPTION_COUNTRYOPTIONS_PANAMA,
    OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
    OPTION_COUNTRYOPTIONS_PARAGUAY,
    OPTION_COUNTRYOPTIONS_PERU,
    OPTION_COUNTRYOPTIONS_PHILIPPINES,
    OPTION_COUNTRYOPTIONS_PITCAIRN,
    OPTION_COUNTRYOPTIONS_POLAND,
    OPTION_COUNTRYOPTIONS_PORTUGAL,
    OPTION_COUNTRYOPTIONS_PUERTO_RICO,
    OPTION_COUNTRYOPTIONS_QATAR,
    OPTION_COUNTRYOPTIONS_RÉUNION,
    OPTION_COUNTRYOPTIONS_ROMANIA,
    OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
    OPTION_COUNTRYOPTIONS_RWANDA,
    OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
    OPTION_COUNTRYOPTIONS_SAINT_HELENA,
    OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
    OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
    OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
    OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
    OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
    OPTION_COUNTRYOPTIONS_SAMOA,
    OPTION_COUNTRYOPTIONS_SAN_MARINO,
    OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
    OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
    OPTION_COUNTRYOPTIONS_SENEGAL,
    OPTION_COUNTRYOPTIONS_SERBIA,
    OPTION_COUNTRYOPTIONS_SEYCHELLES,
    OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
    OPTION_COUNTRYOPTIONS_SINGAPORE,
    OPTION_COUNTRYOPTIONS_SLOVAKIA,
    OPTION_COUNTRYOPTIONS_SLOVENIA,
    OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
    OPTION_COUNTRYOPTIONS_SOMALIA,
    OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
    OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
    OPTION_COUNTRYOPTIONS_SPAIN,
    OPTION_COUNTRYOPTIONS_SRI_LANKA,
    OPTION_COUNTRYOPTIONS_SUDAN,
    OPTION_COUNTRYOPTIONS_SURINAME,
    OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
    OPTION_COUNTRYOPTIONS_SWAZILAND,
    OPTION_COUNTRYOPTIONS_SWEDEN,
    OPTION_COUNTRYOPTIONS_SWITZERLAND,
    OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
    OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
    OPTION_COUNTRYOPTIONS_TAJIKISTAN,
    OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
    OPTION_COUNTRYOPTIONS_THAILAND,
    OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
    OPTION_COUNTRYOPTIONS_TOGO,
    OPTION_COUNTRYOPTIONS_TOKELAU,
    OPTION_COUNTRYOPTIONS_TONGA,
    OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
    OPTION_COUNTRYOPTIONS_TUNISIA,
    OPTION_COUNTRYOPTIONS_TURKEY,
    OPTION_COUNTRYOPTIONS_TURKMENISTAN,
    OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
    OPTION_COUNTRYOPTIONS_TUVALU,
    OPTION_COUNTRYOPTIONS_UGANDA,
    OPTION_COUNTRYOPTIONS_UKRAINE,
    OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
    OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
    OPTION_COUNTRYOPTIONS_UNITED_STATES,
    OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
    OPTION_COUNTRYOPTIONS_URUGUAY,
    OPTION_COUNTRYOPTIONS_UZBEKISTAN,
    OPTION_COUNTRYOPTIONS_VANUATU,
    OPTION_COUNTRYOPTIONS_VENEZUELA,
    OPTION_COUNTRYOPTIONS_VIET_NAM,
    OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
    OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
    OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
    OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
    OPTION_COUNTRYOPTIONS_YEMEN,
    OPTION_COUNTRYOPTIONS_ZAMBIA,
    OPTION_COUNTRYOPTIONS_ZIMBABWE,
    LANDING_TERMS_I_HAVE_READ,
    LANDING_TERMS_THE_USE_DISCLOSURE,
    LANDING_TERMS_THE_TRANSFER_OF,
    LANDING_TERMS_I_UNDERSTAND_THAT,
    OPTION_DOESTHEPARTICULATEMATTER_NO,
    OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
    OPTION_DOESTHEPARTICULATEMATTER_YES,
    I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
    PRODUCT_LOT,
    SHIPPING_DISTRIBUTION_LABEL,
    CARTON_LABEL,
    INTERNAL_PRODUCT_LABEL,
    TITLE_PD_RENAL,
    TITLE_SOLUTIONS,
    TITLE_ACCESS,
    TITLE_ALL_OTHER_PRODUCT,
    REPORTED_PROBLEM,
    LOGIN,
    SYSTEM_MENU,
    INITIATE_PRODUCT_FEEDBACK,
    FEEDBACK_STATUS,
    OKTACALLBACK,
    VALID_EMAIL,
    VALID_NUMERIC,
    PLEASE_UPLOAD_IMAGE,
    VALID_DATE,
    QUANTITY,
    EDIT,
    DELETE,
    LOT_SERIAL_NO,
    LOT_NUMBER_NOT_FOUND,
    SEARCHING_LOT_NUMBER,
    PRODUCT_CODE_NOT_FOUND,
    SEARCHING_PRODUCT_CODE,
    FILE_OF_TYPES_ARE_NOT_ALLOWED,
    THE_FILE_YOU_ARE_ATTEMPTING,
    IMAGE_ICON,
    LOGIN_TO_ACCOUNT,
    SIGN_IN_TO_YOUR_ACCOUNT,
    BAXTER_EMAIL_ADDRESS,
    PASSWORD,
    SIGN_IN,
    UNKNOWN,
    ASKED_UNKNOWN,
    DD_MMM_YYYY,
    DD,
    MMM,
    YYYY,
    SELECT_COUNTRY,
    CHINESE_SIMPLIFIED_CHINESE,
    DUTCH,
    ENGLISH,
    FRENCH,
    GERMAN,
    ITALIAN,
    JAPANESE,
    KOREAN,
    MANDARIN_TRADITIONAL_CHINESE,
    POLISH,
    PORTUGUESE,
    SPANISH,
    THAI,
    TURKISH,
    VIETNAMESE,
    BROWSE,
    FEEDBACK_SUBMITTED,
    YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
    IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
    CLOSE,
    PATIENT_AGE,
    ENTER_AGE,
    PATIENT_DOB,
    RELEVANT_ATTACHMENTS,
    BAXTER_ACCOUNT_CREDENTIALS,
    GET_PRODUCT_DETAILS,
    USE_THE_DIAGRAM_ABOVE_FIGURE_2,
    FACILITY_ADDRESS,
    LABEL_ANOTHER_FACILITY_ADDRESS,
    CHOOSE_PRODUCT_CODE,
    PRIVACY_NOTICE,
    DECLINE,
    OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
    OPTION_COUNTRYOPTIONS_CURAÇAO,
    OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
    OPTION_COUNTRYOPTIONS_ESWATINI,
    FORM_HELP_TEXT,
    YOUR_FIRST_NAME,
    YOUR_LAST_NAME,
    MY_FIRST_NAME,
    MY_LAST_NAME,
    PATIENT_FIRST_NAME,
    PATIENT_LAST_NAME,
    REPORTER_FIRST_NAME,
    REPORTER_LAST_NAME,
    EMPLOYEE_FIRST_NAME,
    EMPLOYEE_LAST_NAME,
    END_USER_CUSTOMER_FIRST_NAME,
    END_USER_CUSTOMER_LAST_NAME,
    ADDITIONAL_CONTACT_FIRST_NAME,
    ADDITIONAL_CONTACT_LAST_NAME,
    COPYRIGHT_BAXTER,
    COPYRIGHT_VERSION,
    ADD_ADDITIONAL_CONTACT,
    CONTACT_ME,
    DO_NOT_CONTACT,
    END_USER_CUSTOMER_FACILITY_NAME,
    END_USER_CUSTOMER_PHONE,
    END_USER_CUSTOMER_EMAIL,
    END_USER_CUSTOMER_FACILITY_ADDRESS,
    SAME_AS_PATIENT_ADDRESS,
    SAME_AS_REPORTER_ADDRESS,
    SAME_AS_END_USER_CUSTOMER_ADDRESS,
    USE_THE_DIAGRAM_ABOVE_FIGURE_3,
    CONTACT_US,
    LANDING_BRIEF_FOR_DEVICE,
    PATIENT_SEX,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
    OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
    ATTENTION_NEEDED,
    SUBMIT_ERR_MSG,
    SUBMIT_RETRY_MSG,
    OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

translations[APP_TITLE] = "Portal para retroalimentación de producto";
translations[LANDING_BRIEF] = "El portal  para retroalimentación de producto de Baxter en línea está diseñado para enviar información confidencial y comentarios sobre los productos de Baxter.";
translations[LANDING_LANGUAGE_SELECTOR] = "Seleccionar idioma de preferencia";
translations[LANDING_COUNTRY_SELECTOR] = "Seleccione el país del evento";
translations[LANDING_TERMS] = "He leído y acepto las Condiciones de uso y la Declaración de privacidad del portal  para retroalimentación de producto de Baxter";
translations[LANDING_TERMS_ERROR] = "Debe leer y aceptar el contenido de los Términos de uso, la Declaración de privacidad y el portal  para retroalimentación de producto de Baxter Términos de uso complementarios y Declaración de privacidad para el Portal  para retroalimentación de producto de Baxter";
translations[LANDING_CAPTCHA_ERROR] = "Comprueba que no eres un robot.";
translations[APP_DESCRIPTION] = "El portal  para retroalimentación de producto de Baxter en línea está diseñado para enviar información sobre productos. Si ha tenido algún problema con un producto Baxter, le recomendamos que comparta los detalles de ese evento. Todos los comentarios son esenciales para que podamos cumplir nuestros objetivos  y mejorar continuamente tanto el  producto como la satisfacción.";
translations[LANDING_TERMS_I_HAVE_READ] = "He leído el Aviso de privacidad vinculado al portal de comentarios sobre productos de Baxter y entiendo que Baxter Healthcare Corporation («Baxter») solicita mi consentimiento para usar, divulgar y procesar mis datos personales para los fines y según se describe en el Aviso de privacidad. Por la presente doy mi consentimiento para:";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "El uso, la divulgación, el almacenamiento y el procesamiento de mis datos personales (incluidos los datos confidenciales, como los datos relacionados con la salud, que elijo proporcionar) para los fines descritos en el Aviso de privacidad.";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "La transferencia de mis datos personales (incluidos los datos confidenciales, como los datos relacionados con la salud, que elijo proporcionar) fuera de mi país a otro país que puede tener leyes de protección de datos menos estrictas o no tener leyes de protección de datos.";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "Comprendo que este consentimiento es voluntario y que puedo cambiar de opinión en cualquier momento y revocar mi consentimiento poniéndome en contacto con Baxter utilizando los datos de contacto que figuran en el Aviso de privacidad. Comprendo que retirar mi consentimiento no afectará a la legalidad del procesamiento antes de su retirada.";
translations[MENU_FEEDBACK_FORM] = "Iniciar retroalimentación sobre producto";
translations[MENU_FEEDBACK_STATUS] = "Comprobar el estado de la retroalimentación";
translations[MENU_FORM_INTAKE] = "Reportante/Información de contacto";
translations[MENU_FORM_EVENT_DETAILS] = "Detalles del evento";
translations[MENU_FORM_PRODUCT_INFO] = "Información del producto";
translations[SYSTEM_FEEDBACK_FORM] = "Iniciar el formulario de retroalimentación de producto";
translations[SYSTEM_FEEDBACK_STATUS] = "Comprobar el estado dela retroalimentación";
translations[SUBMIT_FEEDBACK] = "Haz clic aquí para enviar retroalimentación.";
translations[CHECK_SUBMITTED_FEEDBACK] = "Haz clic aquí para comprobar el estado de las retroalimentaciones  enviadas anteriormente.";
translations[BTN_LAUNCH_FORM] = "Lanzar Formulario";
translations[BTN_CHECK_STATUS] = "Comprobar estado";
translations[FORM_TITLE] = "Formulario para retroalimentación sobre producto.";
translations[FORM_SUB_TITLE] = "Si hay multiples pacientes involucrados, por favor complete una forma para cada paciente.";
translations[FORM_MANDATORY_FIELDS] = "Todos los campos con* son obligatorios";
translations[BUTTON_PREV] = "Previo";
translations[BUTTON_NEXT] = "Siguiente";
translations[BUTTON_SUBMIT] = "Enviar";
translations[SELECT_RESPONSE] = "Seleccionar respuesta";
translations[FUNCTION_ROLE] = "Función/Rol";
translations[CUSTOMER_ACCOUNT_NUMBER] = "Número de cuenta de cliente";
translations[ENTER_CUSTOMER_ACCOUNT] = "Ingresar cuenta de cliente";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "¿Cuál es el número de cuenta del cliente involucrado en el evento reportado?";
translations[EVENT_REPORTED] = "¿Se ha informado anteriormente de este evento (a Baxter o a cualquier otra entidad)?";
translations[REFERENCE_NUMBER] = "Número de referencia asociado a este evento";
translations[ENTER_REFERENCE] = "Ingresar referencia";
translations[WHO_REPORTED_TO] = "¿A quién se ha reportado esto?";
translations[WHO_WAS_NOTIFIED] = "¿Indicar el nombre de quién fue notificado?";
translations[ENTER_NAME] = "Ingresar nombre";
translations[PRODUCT_SURVEILLANCE] = "¿Puede el equipo de vigilangia de producto de Baxter ponerse en contacto con usted  o con otra persona si tenemos más preguntas?";
translations[YOUR_NAME] = "Tu nombre";
translations[OCCUPATION] = "Ocupación";
translations[PHONE_NUMBER] = "Número de teléfono";
translations[ENTER_PHONE_NUMBER] = "Ingresar el número de teléfono";
translations[ENTER_EMAIL] = "Ingresar correo electrónico";
translations[EMAIL_ADDRESS] = "Dirección de correo electrónico";
translations[ENTER_ADDRESS] = "Ingresar dirección de correo electrónico";
translations[ENTER_NA_IF_UNKNOWN] = "Introduzca NA si se desconoce";
translations[FACILITY_HOSPITAL] = "Nombre de la institución/hospital o distribuidor (si aplica)";
translations[ENTER_FACILITY] = "Ingresar institución";
translations[ADDRESS_1] = "Dirección 1";
translations[ADDRESS_2] = "Dirección 2";
translations[CITY] = "Ciudad";
translations[STATE] = "Estado";
translations[POSTAL_CODE] = "Codigo Postal";
translations[COUNTRY] = "Pais";
translations[END_USER_CUSTOMER] = "¿Este problema ha sido descubierto por un usuario final/cliente?";
translations[ADDITIONAL_CONTACT_PERSON] = "Persona adicional de contacto";
translations[ADDITIONAL_PHONE] = "Número de teléfono de contacto adicional";
translations[ADDITIONAL_EMAIL] = "Correo electrónico de contacto adicional";
translations[ANOTHER_FACILITY_ADDRESS] = "Añadir otra institución/dirección";
translations[ANOTHER_FACILITY_HOSPITAL] = "Otro nombre de institución/hospital o distribuidor (si aplica)";
translations[ANOTHER_ENTER_FACILITY] = "Ingresar institución";
translations[ANOTHER_ADDRESS_1] = "Dirección 1";
translations[ANOTHER_ADDRESS_2] = "Dirección 2";
translations[ANOTHER_CITY] = "Ciudad";
translations[ANOTHER_STATE] = "Estado";
translations[ANOTHER_POSTAL_CODE] = "Codigo Postal";
translations[ANOTHER_COUNTRY] = "Pais";
translations[LOT_SERIAL_NUMBER] = "Número de lote/número de serie";
translations[ENTER_LOT_SERIAL_NUMBER] = "Ingresar el número de lote/número de serie";
translations[HELP_LOT_SERIAL_NUMBER] = "Introduzca 'Desconocido' si no conoce el número de lote/serie,  'Preguntado desconocido' si le preguntó al reportante y no lo sabía.";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "Código de producto";
translations[PRODUCT_CODE] = "Código de producto";
translations[ENTER_PRODUCT_CODE] = "Ingresar código de producto";
translations[HELP_PRODUCT_CODE] = "Introduzca 'Desconocido' si no conoce el Codigo de producto,  'Preguntado desconocido' si le preguntó al reportante y no lo sabía.";
translations[NDC] = "Número del Código Nacional de Drogas (NDC)";
translations[ENTER_NDC] = "Ingresar NDC";
translations[UDI] = "Identificador de dispositivo único (UDI)";
translations[ENTER_UDI] = "Ingresar UDI";
translations[PRODUCT_NAME] = "Nombre del producto";
translations[ENTER_PRODUCT_NAME] = "Ingresar el nombre del producto";
translations[HELP_PRODUCT_NAME] = "Proporcione el nombre o la descripción del producto";
translations[BEST_DESCRIBES] = "Haga la selección que mejor describa el problema notificado";
translations[QUANTITY_TO_SELECT] = "Cantidad para seleccionar";
translations[ENTER_QUANTITY] = "Ingresar cantidad";
translations[HELP_QUANTITY] = "Número de productos con el problema reportado";
translations[UNIT] = "Unidad";
translations[AVAILABLE_TO_RETURNED] = "¿Está disponible el producto impactado con el problema notificado para ser devuelto a Baxter para su evaluación?";
translations[PHOTOGRAPH_AVAILABLE] = "¿Hay disponible una fotografía o un vídeo del producto?";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "Asegúrese de que el problema reportado sea visible en la foto o el vídeo.";
translations[UPLOAD_IMAGES] = "Subir imágenes";
translations[REPORTER_NAME] = "Nombre del reportante";
translations[REPORTER_FACILITY] = "Instalación de reportante";
translations[REPORTER_OCCUPATION] = "Ocupación de reportante";
translations[ENTER_NUMBER] = "Ingresar número";
translations[REPORTER_PHONE_NUMBER] = "Número de teléfono del reportante";
translations[REPORTER_EMAIL_ADDRESS] = "Dirección de correo electrónico del reportante";
translations[EMPLOYEE_NAME] = "Search for ";
translations[EMPLOYEE_PHONE_NUMBER] = "Número de teléfono del empleado";
translations[EMPLOYEE_EMAIL_ADDRESS] = "Dirección de correo electrónico del empleado";
translations[RETURNING_FOR_INVESTIGATION] = "¿Cuántas muestras (en unidades) con el problema notificado devuelve para su investigación?";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "Estas muestras deben ser productos con el problema reportado.";
translations[UNUSED_BAXTER_PRODUCT] = "¿Existe un producto Baxter sin usar del mismo lote disponible para ser devuelto a Baxter para su evaluación?";
translations[YOU_INDICATED_SAMPLES] = "Usted indicó que había muestras disponibles para su evaluación, ¿puede llevarlas a su proveedor de atención médica?";
translations[SAMPLE_RETURN_KIT] = "Usted indicó que las muestras estaban disponibles para su evaluación, confirme la dirección proporcionada para enviar el kit de devolución de muestras:";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "Se enviará una caja con una etiqueta prepago a esta dirección para devolver la muestra";
translations[SAME_AS_MY_ADDRESS] = "La misma que mi dirección";
translations[OTHER_CONTACT_NAME] = "Nombre de otro contacto";
translations[OTHER_CONTACT_OCCUPATION] = "Ocupación de otro contacto";
translations[OTHER_CONTACT_PHONE_NUMBER] = "Número de teléfono de otro contacto";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "Dirección de correo electrónico de otro contacto";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "El producto seleccionado lo fabrica otra empresa, ¿podemos proporcionarles su información de contacto si tienen preguntas adicionales sobre su informe?";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "¿Ha solicitado explícitamente el cliente los resultados de la investigación?";
translations[EXPLICITLY_REQUEST_CREDIT] = "¿El cliente solicitó crédito explícitamente?";
translations[PRODUCT_FROM_BAXTER] = "¿El cliente compra el producto directamente a Baxter?";
translations[QUANTITY_REQUESTED_CREDIT] = "Número de lote(s)  y cantidad solicitados para el crédito:";
translations[ENTER_OCCUPATION] = "Ingresar ocupación";
translations[LOT_QUANTITY_NUMBER] = "Ingresar el número de lote y la cantidad";
translations[WHOLESALERS_NAME] = "Cuál es el nombre y la ubicación del distribuidor (ciudad, estado)";
translations[PLACE_WHOLESALERS_NAME] = "Cuál es el nombre y la ubicación del distribuidor (ciudad, estado)";
translations[ADD_PRODUCT_TO_THE_GRID] = "Agregue producto a la tabla";
translations[SAVE] = "Guardar";
translations[CANCEL] = "Cancelar";
translations[ADD_MORE_PRODUCTS] = "AÑADIR más productos";
translations[REPORTER_ADDRESS] = "Dirección del reportante";
translations[ATTACHMENTS] = "Adjuntos";
translations[DATE_OF_EVENT] = "Fecha del evento";
translations[DATE_OF_EVENT_MSG] = "La fecha del evento no puede ser posterior a la fecha en que se notificó por primera vez al empleado de Baxter. Ingresar una fecha válida.";
translations[HELP_DATE_OF_EVENT] = "si hay varias fechas conocidas en las que se produjo el evento, rellene un formulario para cada fecha.";
translations[DATE_BAXTER_EMPLOYEE] = "Fecha en que se notificó por primera vez a un empleado de Baxter";
translations[DATE_MESSAGE_BAXTER_EMPLOYEE] = "(La fecha proporcionada no tiene que ser la misma que la fecha en que la informacion se ingresa.)";
translations[DURING_WHAT_PROCESS] = "¿Durante qué paso(s) del proceso se produjo el evento?";
translations[WAS_THE_PATIENT] = "¿Estaba conectado el paciente (tratamiento en curso) en el momento del evento?";
translations[WERE_YOU_CONNECTED] = "Estaba conectado(Tratamiento en curso) al momento del evento?";
translations[PROVIDE_ANY_ADDITIONAL] = "Proporcionar detalles adicionales relacionados con el evento/problema";
translations[HELP_YOU_IDENTIFIED_MORE] = "Ha identificado más de un producto y un problema, por favor, aclare qué productos tenían los problemas reportados";
translations[ENTER_DETAILS] = "Ingresar los detalles";
translations[PROVIDE_ANY_ATTACHMENT] = "Proporcionar cualquier archivo adjunto según corresponda";
translations[WAS_NEGATIVE_MEDICAL] = "¿Hubo algún impacto médico negativo, síntoma (s) o lesión como resultado del evento?";
translations[WAS_MEDICAL_INTERVENTION] = "¿Se proporcionó tratamiento, intervención médica o aumento de la atención para contrarrestar el evento reportado?";
translations[PROVIDE_DETAILS] = "Proporcionar detalles";
translations[REQUIRED_TREATMENT] = "Tratamiento/intervención médica requeridos";
translations[ENTER_TREATMENT] = "Ingresar tratamiento";
translations[RELEVANT_TESTS] = "Pruebas relevantes, incluidos datos de laboratorio:";
translations[HELP_RELEVANT_TESTS] = "Ingresar pruebas pertinentes";
translations[RELEVANT_MEDICAL_HISTORY] = "Historial médico relevante, incluidas afecciones médicas preexistentes:";
translations[ENTER_HISTORY] = "Ingresar historial";
translations[PATIENT_NAME] = "Search f";
translations[PATIENT_INITIALS] = "Iniciales del paciente o nombre completo. Si hay multiples pacientes involucrados, por favor complete una forma para cada paciente.";
translations[PATIENT_PHONE_NUMBER] = "Número de teléfono del paciente";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "No deseo informar";
translations[PATIENT_EMAIL_ADDRESS] = "Dirección de correo electrónico del paciente";
translations[PATIENT_ADDRESS] = "Dirección del paciente";
translations[SAME_ADDRESS] = "Misma dirección";
translations[DRUG_BEING_USED] = "¿Se estaba usando un medicamento Baxter en el momento del evento?";
translations[PATIENT_IDENTIFIER] = "Identificación del  paciente";
translations[PATIENT_AGE_OR_DOB] = "Edad del paciente o fecha de nacimiento";
translations[ENTER_PATIENT_AGE] = "mm/dd/aaaa, Ingresar la edad del paciente";
translations[PATIENT_GENDER] = "Género del paciente";
translations[PATIENT_WEIGHT] = "Peso del paciente";
translations[ENTER_WEIGHT] = "Ingresar peso";
translations[PATIENT_WEIGHT_UNIT] = "Unidad de peso del paciente";
translations[MY_NAME] = "Mi nombre";
translations[ENTER_IN_YOUR_CONTACT] = "Ingresar su información de contacto";
translations[MY_PHONE_NUMBER] = "Mi número de teléfono";
translations[MY_EMAIL_ADDRESS] = "Mi dirección de correo electrónico";
translations[MY_ADDRESS] = "Mi dirección";
translations[NAME_OF_BAXTER_DRUG] = "Nombre del medicamento Baxter";
translations[ENTER_DRUG_NAME] = "Ingresar el nombre del medicamento";
translations[PLEASE_PROVIDE_THE_NAME] = "Proporcione el nombre o el código de producto del medicamento de Baxter. Proporcione el nombre de todos los medicamentos de Baxter que se usaban en el momento del problema informado.";
translations[SELECT_THE_COMPONENT] = "Seleccione el componente que tuvo el problema";
translations[USE_THE_DIAGRAM] = "Utilice el diagrama anterior (Figura 1) para determinar la ubicación del desechable dañado.";
translations[TYPE_OF_DAMAGE] = "Describa el tipo de daño";
translations[PLEASE_ENTER_VALUE] = "Ingresar el valor";
translations[WAS_THE_PRODUCT_KINKED] = "¿El producto estaba torcido, agrietado, doblado, cortado, etc.?";
translations[WERE_ANY_CLEANING] = "¿Se utilizaron soluciones de limpieza, disolventes o desinfectantes en el producto?";
translations[WHAT_WAS_THE_DISINFECTANT] = "¿Cuál era el nombre/marca del desinfectante y cómo se usó?";
translations[NOTE_BAXTER_LABELING] = "La etiqueta de Baxter establece no aplicar lejía, peróxido de hidrógeno, alcohol o antiséptico que contenga alcohol al equipo. El uso de estos productos puede provocar que el producto desarrolle grietas.";
translations[SELECT_ALL_THAT_APPLY] = "Selecciona todo lo que corresponda";
translations[DID_FOLLOWING_OCCUR] = "¿Se ha producido alguna de las siguientes situaciones?";
translations[SELECT_THE_LOCATION] = "Selecciona la ubicación con los daños en el Minicap";
translations[WAS_THE_PRODUCT_EXPOSED] = "¿El producto fue expuesto a una fuerza excesiva (es decir, apretado, golpeado, impactado, etc.) antes de que ocurriera el problema?";
translations[HOW_LONG_TRANSFER] = "¿Cuánto tiempo lleva en uso el equipo de transferencia?";
translations[WAS_THERE_DIFFICULTY] = "¿Hubo alguna dificultad al abrir o cerrar el tapón giratorio?";
translations[WAS_DEVICE_OR_TOOL] = "¿Se utilizó un dispositivo o herramienta para abrir o cerrar el tapón giratorio?";
translations[DESCRIBE_HOW_PRODUCT] = "Describa cómo es difícil usar el producto (Selecciona todo lo que corresponda)";
translations[DID_YOU_OBSERVE] = "¿Ha observado algún daño (por ejemplo, corte, agujero, grieta) con el producto?";
translations[WERE_DIFFICULTIES_PUTTING] = "¿Hubo dificultades para poner el Minicap en el equipo de transferencia y girar en el sentido de las agujas del reloj hasta que estuviera firmemente asegurado?";
translations[WAS_THE_TRANSFER] = "¿Se ha reemplazado el equipo de transferencia debido a este evento?";
translations[SELECT_TYPE_OF_FLOW] = "Seleccione el tipo de problema de flujo";
translations[WAS_ANYTHING_BLOCKING] = "¿Hubo algo que bloqueara el flujo?";
translations[WAS_ANY_ALARM] = "¿Hubo alguna alarma?";
translations[SELECT_BEST_DESCRIBE] = "Seleccione la opción que mejor describa el problema";
translations[WERE_THE_MINICAPS] = "¿Los Minicaps estuvieron expuestos o almacenados en un ambiente frío/calor?";
translations[WAS_THE_SPONGE_VISIBLE] = "¿Era visible la esponja dentro del Minicap?";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "¿Dónde se encuentra la materia particulada/material extraño?";
translations[DESCRIBE_THE_EXACT_LOCATION] = "Describa la ubicación, el tamaño, la forma y el color exactos de la materia particulada/material extraño:";
translations[WAS_THE_PARTICULATE_MATTER] = "¿Estaba incrustada la materia particulada/material extraño en el producto?";
translations[DOES_THE_PARTICULATE_MATER] = "¿Parece que la materia particulada/material extraño son partes del mismo material del producto?";
translations[WHAT_COMPONENT_DOES] = "¿De qué componente parece proceder la partícula?";
translations[SELECT_CONNECTION_ISSUE] = "Seleccione la opción que mejor describa el problema de conexión";
translations[WERE_ASSIST_DEVICES] = "¿Se utilizaron dispositivos o herramientas de asistencia para hacer la conexión al equipo desechable?";
translations[WERE_ANY_DIFFICULTIES] = "¿Se observaron dificultades durante la conexión inicial o la desconexión?";
translations[PROVIDE_PRODUCT_INFORMATION] = "Proporcionar la información del producto del segundo producto que estuvo involucrado en el problema de conexión";
translations[WERE_THE_SPIKE_LUER] = "¿Los conectores de espiga/luer giraron en el sentido de las agujas del reloj hasta que estaban firmemente asegurados?";
translations[BAXTER_LABELING_STATES] = "El etiquetado de Baxter establece que todas las conexiones al desechables estén firmes y ajustadas antes de comenzar la terapia.";
translations[WERE_PETS_OR_ANIMALS] = "¿Había mascotas o animales que pudieran haber dañado el equipo desechable?";
translations[BAXTER_LABELING_CONTAMINATION] = "El etiquetado de Baxter establece que la contaminación de las vías de fluidos puede producirse si una mascota o animal muerde los suministros desechables. Para reducir este riesgo, no realice diálisis en la misma habitación que las mascotas o los animales.";
translations[WERE_OTHER_ISSUES] = "¿Hubo otros problemas o dificultades asociados con la espiga/luer (es decir, agrietada, deformada, doblada, etc.)?";
translations[WAS_MINICAP_TWISTED] = "¿El Minicap fue apretado en el sentido de las agujas del reloj en el conector del equipo de transferencia hasta que estuviera firmemente asegurado?";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "¿Hubo dificultades para poner el Minicap en el equipo de transferencia?";
translations[DID_TRANSFER_SET_CONNECTORS] = "¿Los conectores del equipo de transferencia presentaron algún daño o residuo visible en las roscas?";
translations[WHAT_WAS_THE_ALARM] = "¿Cuál fue la alarma?";
translations[WHERE_OBSERVED_DAMAGE] = "¿Dónde estaba el daño observado (seleccione todo lo que corresponda)?";
translations[SELECT_THE_TYPE_OBSERVED] = "Seleccione el tipo de daño observado (seleccione todo lo que corresponda):";
translations[DID_DAMAGE_CAUSE_LEAK] = "¿El daño ha causado una fuga?";
translations[WAS_THE_SHIPPING_CARTON] = "¿Se abrió la caja de envío con un objeto punzante?";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "Seleccione el tipo de problema de flujo observado";
translations[HOW_LONG_WAS_STORAGE] = "¿Cuánto tiempo estuvo almacenado antes de que se encontrara el producto expirado?";
translations[WAS_THERE_AN_ADAPTER] = "¿Se utilizó un adaptador o cualquier otro dispositivo (s) con el producto?";
translations[NAME_AND_MODEL] = "¿Cuál es el nombre y el modelo del adaptador o de cualquier otro dispositivo utilizado?";
translations[NAME_VAPORIZER] = "¿Cuál es el nombre y el modelo del vaporizador?";
translations[WAS_VIAL_INVERTED] = "¿Se invirtió el vial adjunto antes de exprimir la solución en el vial?";
translations[WHAT_VIAL_USED] = "¿Cuál es la información de producto del vial utilizado?";
translations[DRUG_NAME_MANUFACTURER] = "Nombre del medicamento, fabricante, tamaño del vial";
translations[WERE_BREAK_FRANGIBLE] = "¿Pudo romper el frangible correctamente usando un movimiento de ida y vuelta?";
translations[WAS_ALARM_ASSOCIATED] = "¿Hubo alguna alarma asociada con el no flujo?";
translations[WHAT_PART_DISCOLORED] = "¿Qué parte del producto estaba decolorada? (selecciona todo lo que corresponda)";
translations[DESCRIBE_DISCOLORATION] = "Describa la decoloración (describa color, matiz, tinta, sombra, etc.):";
translations[HOW_PRODUCT_STORED] = "¿Cómo se almacenó el producto?";
translations[DOES_DISCOLORATION_APPEAR] = "¿La decoloración parece opaca, nebulosa, turbia y/o tiene marcas circular/de peinel?";
translations[WHICH_CHAMBER_DISCOLORED] = "¿Qué cámara estaba descolorida de la bolsa?";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "¿Ya se ha roto o activado el sello o el frangible entre cámaras?";
translations[WAS_DISCOLORATION_NOTICED] = "¿Se notó la decoloración a través de la mirilla del vaporizador?";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "Seleccione una opción que describa el problema de forma más específica:";
translations[WHAT_DEVICE_HAD_ALARM] = "¿Qué dispositivo tenía la alarma?";
translations[WHAT_MISSING_MISASSEMBLED] = "¿Qué componente faltaba o está mal ensamblado?";
translations[RECONSTITUTION_ISSUE] = "Proporcionar una descripción más específica del problema de la reconstitución";
translations[WHAT_MEDICATION_SOLUTION] = "¿Con qué medicamento o solución se estaba reconstituyendo el producto?";
translations[WHAT_VOLUME_MEDICATION] = "¿Cuál es el volumen de medicamento/solución utilizada para reconstituir?";
translations[WHAT_DEVICES_RECONSTITUTION] = "Qué otros dispositivos se utilizaron durante la reconstitución (nombre/fabricante, tamaño/calibre de aguja, etc.)";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "¿El producto estuvo expuesto al calor?";
translations[DESCRIBE_EXPOSURE] = "Describir la exposición (temperatura, durante cuánto tiempo, etc.)";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "¿Qué técnica se utilizó para activar la solución?";
translations[WAS_DAMAGE_OBSERVED] = "¿Se observó algún daño en el producto antes de la activación?";
translations[DESCRIBE_THE_DAMAGE] = "Describa el daño:";
translations[APPROXIMATELY_SOLUTION_POWDER] = "Aproximadamente, ¿cuánta solución o polvo se subllenó  o se sobrelleno?";
translations[WAS_LEAK_OBSERVED] = "¿Se ha observado alguna fuga?";
translations[WHAT_FEATUR_DIFFICULT_USE] = "¿Qué componente o característica del producto es difícil de usar?";
translations[HOW_WAS_DIFFICULT_USE] = "¿Cómo fue difícil usar el producto?";
translations[WHERE_MATTER_FOREIGN] = "¿Dónde se encuentra la materia particulada/material extraño?";
translations[DOES_PARTICULATE_MATTER] = "¿Parece que la materia particulada/material extraño son piezas de material del producto?";
translations[DESCRIBE_EXACT_LOCATION] = "Describa la ubicación exacta, el color, el tamaño, la forma y la textura de la materia particulada/material extraño:";
translations[WAS_MATTER_FOREIGN] = "¿La materia particulada/material extraño estaba incrustado en el producto (no se movía libremente)?";
translations[WHEN_MATTER_FOREIGN] = "¿Cuándo se observó la materia particulada/material extraño?";
translations[PROVIDE_INFORMATION_MEDICATION] = "Proporcionar información de producto del medicamento añadido:";
translations[PRODUCT_NAME_CODE_NUMBER] = "Nombre del producto, código de producto, número de lote del producto, nombre de la marca";
translations[DESCRIBE_SPIKING] = "Describa la técnica de espigado o reconstitución que se utilizó:";
translations[INCLUDE_NEEDLE] = "Incluye tamaño/calibre de aguja, ángulo de punción/perforación, número de intentos";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "¿Qué equiipo de administración o dispositivo de reconstitución se utilizó?";
translations[INCLUDE_MANUFACTURER] = "Incluir fabricante, nombre del producto, código de producto, lote de productos";
translations[WAS_MEDICATION_ADDITIVE] = "¿Se ha añadido al producto un medicamento, aditivo o solución de reconstitución?";
translations[WHAT_MEDICATION_ADDITIVE] = "¿Qué medicamento, aditivo o solución de reconstitución se añadió?";
translations[WHAT_STATE_OF_PRODUCT] = "¿Cuál era el estado del producto cuando se observó la nubosidad o el precipitado?";
translations[AFTER_UNITS_SAT] = "Después de que las unidades se asentaron y alcanzaron la temperatura ambiente, ¿desapareció la nubosidad o el precipitado?";
translations[DID_ATTEMPT_AGITATE] = "¿Inentó agitar la unidad?";
translations[DID_PRECIPITATE_DISSOLVE] = "¿Se disolvió el precipitado?";
translations[WHAT_STORAGE_TEMPERATURE] = "¿Cuáles fueron las condiciones y la temperatura de almacenamiento del producto?";
translations[PROVIDE_TEMPERATURE_LOCATION] = "Proporcionar temperatura, ubicación, almacenado dentro o fuera de la sobrebolsa/caja de cartón, en VSC/caja intermedia, unidades individuales";
translations[ARE_TEMPERATURE_LOGS] = "¿Están disponibles los registros de temperatura de los congeladores en los que se almacena el producto?";
translations[LOGS_CAN_BE_ATTACHED] = "Los registros se pueden adjuntar directamente a este formulario, si están disponibles en el momento del envío";
translations[IS_THE_STORAGE_UNIT] = "¿La unidad de almacenamiento (congelador o refrigerador) está calibrada y controlada la temperatura?";
translations[HOW_PRODUCT_THAWED] = "¿Cómo se descongeló el producto?";
translations[WHAT_STORAGE_CONDITIONS] = "¿Cuáles fueron las condiciones de almacenamiento del producto? (temperatura, ubicación, almacenado dentro o fuera de la sobrebolsa/caja de cartón)";
translations[WAS_ANY_DAMAGE] = "¿Se ha observado algún daño en el producto o problema?";
translations[MORE_SPECIFIC_INFORMATION] = "Proporcione información más específica:";
translations[WHAT_PURPOSE_INDICATION] = "¿Cuál es el propósito o la indicación del tratamiento para el paciente?";
translations[WHAT_ROUTE_ADMINISTRATION] = "¿Cuál fue la vía de la administración?";
translations[WHAT_DATE_ADMINISTRATION] = "¿Cuál fue la fecha de administración y duración?";
translations[WHAT_DOSAGE_STRENGTH] = "¿Cuál fue la dosis/potencia administrada al paciente?";
translations[WAS_RECENT_PRESCRIPTION] = "¿Ha habido algún cambio de prescripción reciente?";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "¿Cuáles fueron los detalles de almacenamiento/temperatura del producto (ubicación del almacenamiento/refrigerador/congelador, etc.)?";
translations[WERE_ANY_ADJUSTMENTS] = "¿Hubo algún ajuste en la solución o aditivos antes de la administración?";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "Seleccione la descripción más adecuada del problema:";
translations[SELECT_LABELING_ISSUE] = "Seleccione la descripción más adecuada del problema de etiquetado:";
translations[WAS_CONNECTION_SECURE] = "¿La conexión estaba segura y totalmente ajustada?";
translations[WAS_EXPIRED_PRODUCT] = "¿Se administró el producto expirado a un paciente?";
translations[WAS_COMPONENT_DAMAGED] = "¿Habia algún componente dañado?";
translations[WERE_ABNORMALITIES_DAMAGE] = "¿Se detectaron anomalías o daños en el producto?";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "¿Cuál es el número de pedido de compra?";
translations[WHAT_DATE_OF_ADMINISTRATION] = "¿Cuál fue la fecha de la administración?";
translations[WHAT_WAS_EXPIRATION_DATE] = "¿Cuál era la fecha de expira del producto?";
translations[DESCRIBE_WAS_INCORRECT] = "Describa qué estaba incorrecto, incompleto, faltante, ilegible en la etiqueta o qué era demasiado similar (a otro producto) en la etiqueta:";
translations[WHAT_SCANNER_USED] = "¿Qué tipo de escáner se utilizó?";
translations[WAS_OVERPOUCH_POUCH] = "¿El producto seguía en la bolsa secundaria o pouch durante el escaneo?";
translations[WHAT_BACKGROUND_COLOR] = "¿Cuál era el color del fondo al escanear?";
translations[DO_ALL_OF_THE_LABELS] = "¿Todas las etiquetas (producto, caja/caja de cartón, envío/distribución) tienen la misma información del producto?";
translations[PRODUCT_INFORMATION] = "Información del producto";
translations[IS_A_BARCODE_SCANNER] = "¿Se utiliza un escáner de códigos de barras en sus instalaciones?";
translations[HOW_ARE_THESE_PRODUCTS] = "¿Cómo se almacenan estos productos en la instalación?";
translations[WHAT_INFORMATION_INCORRECTLY] = "¿Qué información se ha mostrado incorrectamente cuando se escanea?";
translations[WAS_THERE_LEAK] = "¿Se observó una fuga o humedad?";
translations[WHERE_LEAK_OBSERVED] = "¿Dónde se observó la fuga, qué componente tenía fugas?";
translations[WAS_FRANGIBLE_OBSERVED] = "¿Se observa que se rompió el frangible?";
translations[IS_MOISTURE_CLEAR] = "¿Es clara la humedad?";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "¿Quién es su distribuidor?";
translations[WHAT_MANUFACTURER_MEDICATION] = "¿Cuál es el fabricante, el nombre del medicamento y el tamaño del vial utilizado?";
translations[WHAT_GAUGE_NEEDLE] = "¿Cuál es el calibre de la aguja utilizada, el fabricante y el número de veces que se pinchó el sitio?";
translations[WHAT_ADMINISTRATION_SET] = "¿Qué equipo  de administración se utilizó?";
translations[WAS_DIFFICULTY_SPIKING] = "¿Hubo dificultad para espigar?";
translations[WERE_FOLLOWING_SCENARIOS] = "¿Se produjo alguno de los siguientes escenarios con la fuga?";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "¿Se observó que el frangible tenía daños o defectos?";
translations[WHAT_AMOUNT_PRESSURE] = "¿Qué cantidad de presión se aplicó y durante qué duración?";
translations[WAS_BAG_COMPLETELY] = "¿Se insertó la bolsa completa y correctamente en el infusor (estaba un extremo fuera del infusor)?";
translations[WHAT_MANUFACTURER_MODEL] = "¿Cuál es el fabricante, el modelo y el tamaño del infusor?";
translations[WHAT_PRESSURE_PRIOR] = "¿Cuál era la presión antes de que se detectara la fuga?";
translations[LIST_THE_VAPORIZER] = "Proporcione el fabricante y el nombre/modelo del vaporizador";
translations[APPROXIMATELY_HOW_MUCH] = "¿Aproximadamente cuánto líquido se derramó?";
translations[WAS_THE_BOTTLE_DIFFICULT] = "¿Fue difícil insertar la botella en el vaporizador?";
translations[WERE_VISIBLE_DEFECTS] = "¿Hubo algún defecto visible?";
translations[SELECT_THE_OPTION] = "Seleccione la opción que mejor describa el problema de conexión";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "Proporcionar la información del producto del segundo producto que estuvo involucrado en el problema de conexión";
translations[WHICH_PART_SEPARATED] = "¿Qué parte (s) del producto se separó?";
translations[WHAT_COMPONENT_DISCOLORED] = "¿Qué componente está decolorado?";
translations[SELECT_DESCRIBES_DISCOLORATION] = "Seleccione la opción que mejor describa la decoloración:";
translations[WAS_THE_SET_DISCOLORED] = "¿Se decoloró el equipo cuando se retiró del paquete?";
translations[DID_SET_CHANGE_COLOR] = "¿El equipo cambió de color después de añadir el medicamento?";
translations[WHAT_MEDICATION_ADDED] = "¿Qué medicamento se añadió antes del cambio de color?";
translations[WHERE_MATERIAL_LOCATED] = "¿Dónde se encuentra la materia particulada/material extraño?";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "Describa la materia particulada/material extraño (apariencia/color/ tamaño):";
translations[WAS_EMBEDDED_PLASTIC] = "¿La materia particulada/material extraño estaba suelto o incrustado en el plástico?";
translations[WAS_THERE_A_PRECIPITATE] = "¿Hubo un precipitado o cambio de color de la infusión o solución que no se esperaba?";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "¿Qué medicamentos/soluciones se han infundido a través del equipo?";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "¿Dónde se produjo el daño o qué componente (s) se vio afectado (seleccione todos los que correspondan)?";
translations[WHAT_DAMAGE_ISSUE] = "¿Qué tipo de daño o problema se observó (seleccione todo lo que corresponda)?";
translations[DID_ISSUE_RESULT] = "¿Este problema dio lugar a una fuga?";
translations[WAS_PATIENT_CONNECTED] = "¿El paciente estaba conectado al producto?";
translations[WAS_PRODUCT_REPLACED] = "¿Se ha sustituido el producto por un nuevo producto?";
translations[WHICH_SITUATION_BEST] = "Qué situación describe mejor el problema de separación y conexión";
translations[SELECT_MOST_LABELING_ISSUE] = "Seleccione la descripción más adecuada del problema de etiquetado:";
translations[WHAT_INFORMATION_DISPLAYED] = "¿Qué información se ha mostrado?";
translations[WHAT_SCANNER_WAS_USED] = "¿Qué tipo de escáner se utilizó?";
translations[INCLUDE_THE_MODEL_NAME] = "Incluir el nombre del modelo";
translations[WAS_PRODUCT_ORDERED] = "¿Se ha pedido el producto directamente a Baxter o a otro distribuidor?";
translations[WHERE_LEAK_COMING] = "¿De dónde viene la fuga (seleccione todo lo que corresponda)?";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "¿Se produjo alguno de los siguientes escenarios con la fuga?";
translations[WAS_POWER_INJECTOR] = "¿Se utilizó el producto con un inyector de potencia?";
translations[WHAT_INJECTOR_USED] = "¿Qué inyector de potencia se utilizó?";
translations[MANUFACTURER_NAME_CODE_LOT] = "Fabricante, nombre del producto, código de producto, lote de productos";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "Describa qué es incorrecto, incompleto, faltante, ilegible o modificado en la etiqueta:";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "Proporcionar la información del producto del segundo producto que estuvo involucrado en la desconexión";
translations[WHICH_COMPONENTS_WERE_FOUND] = "¿Qué componentes se descubrió que tienen grietas o roturas?";
translations[DESCRIBE_CUT_HOLE_SLICE] = "Describa la ubicación exacta del tubo que tenía el corte, el orificio o la rebanada:";
translations[WAS_LEAK_ORIGINATING] = "¿La fuga se originó en la abertura del sitio de inyección?";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "Proporcionar la información del producto del segundo producto que estuvo involucrado en un problema de desconexión/conexión";
translations[WHICH_SPECIFIC_BONDED] = "¿Qué componentes conectados específicos se encontraron separados?";
translations[WERE_VISIBLE_IRREGULARITIES] = "¿Hubo irregularidades o daños visibles en el producto/componentes implicados?";
translations[WAS_SUCCESSFUL_CONNECTION] = "¿Se estableció finalmente una conexión o desconexión satisfactoria (sin tener que reemplazar el producto)?";
translations[WAS_TOOL_USED_ASSIST] = "¿Se utilizó una herramienta para ayudar con la conexión/desconexión?";
translations[WERE_LUER_CONNECTIONS] = "Se verificaron todas las conexiones de Luer para asegurarse de que estaban firmes antes de usarlas (por copia de etiqueta)";
translations[WAS_PRODUCT_SECURELY] = "¿El producto se conectó de forma firme con otro producto antes de desconectarse?";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "¿Qué situación describe mejor el problema de flujo?";
translations[WHAT_FLOWING_BACKWARDS] = "¿Qué estaba fluyendo hacia atrás?";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "Describa los componentes desde los que comenzó el reflujo hasta donde se detuvo:";
translations[DO_SITUATIONS_APPLY] = "¿Alguna de estas situaciones se aplica a este evento?";
translations[WHICH_SPECIFIC_AREA] = "¿Qué área específica del equipo o componente se asoció a los problemas de flujo?";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "¿El flujo se veía previamente a través del equipo o componente?";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "Se observó alguna de las siguientes características:";
translations[WHERE_SIMULTANEOUS_FLOW] = "¿Entre dónde estaba el flujo simultáneo ?";
translations[WHAT_TYPE_HANGER] = "¿Qué tipo de atril/tubo se utilizó?";
translations[WHAT_WAS_HANGER_LENGTH] = "¿Cuál era la longitud del atril/tubo y/o el fabricante?";
translations[WHICH_BAG_LOWER] = "¿Qué bolsa estaba más baja?";
translations[WHAT_Y_SITE_WAS] = "¿A qué sitio en Y estaba conectado el equipo secundario?";
translations[WHAT_COMPONENT_WITHIN] = "¿De Qué componente del equipo no se puede eliminar la solución o la sangre?";
translations[WAS_COMPONENT_SET_REPLACED] = "¿Se ha sustituido el componente/equipo después de que no se ha podido limpiar?";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "¿Cuál era el volumen de líquido que debia infundirse al paciente y el período de tiempo prescrito?";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "¿Cuál fue el volumen de líquido que se infundió realmente en el paciente y durante qué período de tiempo?";
translations[WAS_USED_WITH_PUMP] = "¿Se usó el equipo con una bomba?";
translations[DID_CLAMP_FAIL] = "¿Una llave reguladora falló para detener o controlar el flujo?";
translations[WHAT_CLAMP_FAILED] = "¿Qué llave/pinza falló?";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "¿Se observó algún problema con la pinza?";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "¿Alguna de estas otras situaciones describe el problema del producto (selecciona todo lo que corresponda)?";
translations[DESCRIBE_ALARM_OBSERVED] = "Describa la alarma observada:";
translations[INCLUDE_ANY_MESSAGES] = "Incluir mensajes y códigos de error asociados a la alarma";
translations[WHICH_CLAMP_HAD_ISSUE] = "¿Qué pinza tuvo el problema?";
translations[WHICH_TYPE_CLAMP_ISSUE] = "¿Qué tipo de problema de pinza se ha producido (seleccione todo lo que corresponda)?";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "Seleccione el escenario que mejor describa el problema:";
translations[PROVIDE_MORE_DETAILS] = "Proporciona más detalles sobre cómo es difícil usar el producto:";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "Proporcione más detalles sobre las instrucciones que resultaron difíciles de seguir/entender:";
translations[DESCRIBE_THE_SMELL] = "Describa el olor y de dónde viene:";
translations[WAS_ISSUES_WITH_SET] = "¿Se observó algún problema con el equipo?";
translations[WHERE_LEAK_LOCATED] = "¿En qué parte del producto se encuentra la fuga?";
translations[DID_OCCUR_WITH_LEAK] = "¿Se produjo alguna de las siguientes situaciones con la fuga?";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "Proporcionar la información del producto del segundo producto que estuvo involucrado en la desconexión";
translations[DID_OCCURRED_WITH_THE_LEAK] = "¿Se produjo alguno de los siguientes escenarios con la fuga?";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "¿Dónde se dañó el producto?";
translations[SELECT_ALL_APPLY] = "Selecciona todo lo que corresponda";
translations[DESCRIBE_OBSERVED_DAMAGE] = "Describir el daño observado";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "¿Qué componente del producto se decoloró?";
translations[DESCRIBE_HUE_TINT_SHADE] = "Describir el color observado (matiz, tinte, sombra, etc.):";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "Bolsa interior o exterior, temperatura, exposición a la luz, etc.";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "Describa la ubicación, el tamaño, la forma y el color exactos de la materia particulada/material extraño:";
translations[DOES_THE_PARTICULATE_MATTER] = "¿Parece que la materia particulada/material extraño es material del producto?";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "¿Estaba incrustada la materia particulada/material extraño?";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "¿Parece que la materia particulada/material extraño son partes del mismo material del producto?";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "¿En qué parte del producto se produjo el problema?";
translations[LIST_COMPONENTS_IF] = "Lista de componentes. Si se ha involucrado un segundo producto, proporcione el fabricante, el nombre del producto, el código del producto, el lote del producto";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "¿Se observaron irregularidades o daños visibles?";
translations[SELECT_OPTION_FLOW_ISSUE] = "Seleccione la opción que mejor describa el problema de flujo";
translations[DESCRIBE_IRREGULARITIES] = "Describir irregularidades o daños y si se observaron daños antes de la conección/desconexión o si se produjo durante la conexión/desconexión";
translations[HOW_PRODUCT_SETUP] = "¿Cómo se configuró el producto?";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "Seleccione la descripción más adecuada del problema de etiquetado:";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "Describa qué estaba incorrecto, incompleto, faltante, ilegible en la etiqueta o qué era demasiado similar (a otro producto) en la etiqueta:";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "¿Estaba dañado el producto dentro de la caja de envío?";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "¿Qué producto se suponía que debía recibirse?";
translations[IF_PRODUCT_CODE_NOT] = "Si el código del producto no está disponible, proporcione la descripción del producto";
translations[WAS_THE_CASE_MISSING] = "¿Faltaban hielo seco o paquetes de gel refrigerado en la caja?";
translations[WHAT_CARRIER_DELIVERED] = "¿Qué transportista ha entregado su producto?";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "¿Cuál es el número de pedido de compra?";
translations[WHAT_QUANTITY_MISSING_UNITS] = "¿Cuál es la cantidad de unidades que faltan?";
translations[WAS_EXPIRED_PRODUCT_USE] = "¿Se ha utilizado el producto expirado?";
translations[APPLY_TO_EACH_UNIT] = "SI el evento ocurrió en más de una unidad, las preguntas a continuación aplican para cada unidad.";
translations[TERMS_CONDITIONS] = "Términos y condiciones";
translations[PRIVACY_POLICY] = "Política de privacidad";
translations[PRIVACY_NOTICE] = "Aviso de Privacidad";
translations[COOKIE_POLICY] = "Política de cookies";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "Preguntado desconocido";
translations[OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE] = "Empleado Baxter";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "Cuidador de paciente";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "Distribuidor";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "Profesional de la salud";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "Paciente";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "Otro";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "Después del uso";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "Antes de usar";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "Durante la Configuración/Preparación/Mezcla";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "Durante la terapia";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "Multiples pasos";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "No especificado";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "Miembro de la familia";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "Enfermera";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Enfermera Practicante";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Otro profesional de la salud";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "Médico";
translations[OPTION_UNITOPTIONS_BOXES] = "Cajas";
translations[OPTION_UNITOPTIONS_PALLETS] = "Palets";
translations[OPTION_UNITOPTIONS_UNITS] = "Unidades";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "Alarma Condición";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "Dañado";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "Difícil de usar";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "Decolorados";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "Problemas de flujo";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "Problemas de etiquetado";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "Fugas /Humedad excesiva";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "Material Particulado / Material Externo";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "Reacción del Paciente / Evento adverso";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "Consulta sobre producto";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "Separación / Conexión";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "Problemas de Envio / Producto Expirado";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "Mujer";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "Indiferenciado";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "Hombre";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "Se niega a contestar";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "Administrador/Supervisor";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "Ingeniero Biomédico";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "Representante de la  empresa";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "Dentista Usuario";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "Distribuidor";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "Miembro de la familia";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "Usuario";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "Enfermera";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Enfermera Practicante";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Otro profesional de la salud";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "Farmacéutico";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "Técnico de farmacia";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "Médico";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "Paciente";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "Gerente de  Riesgos";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "Otro";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "Contacte Persona de contacto adicional";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "Contacteme";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "Contacte a Otro";
translations[OPTION_REPORTEDTOOPTIONS_BAXTER] = "Baxter";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "China FDA";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "FDA";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "Health Canada";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "PMDA (Japón)";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TUV";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "TGA (Australia)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "Una mascota o animal podría haber causado el problema";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "Se utilizó un objeto punzante o herramienta para abrir la caja de cartón o sobrebolsa";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "El producto estaba expuesto a una fuerza excesiva (es decir, apretado, golpeado, impactado, etc.) antes de que ocurriera el problema";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = " El producto fue expuesto o almacenado en un ambiente frío/calor";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "Caja ";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "Minicap";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "Bolsa";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "El equipo de transferencia estaba demasiado ajustado";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "El equipo de transferencia estaba demasiado suelto";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "El equipo de transferencia no pudo cerrarse por completo";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "El equipo de transferencia no pudo abrirse por completo";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "La abrazadera giratoria estaba tan ajustada que el juego de transferencia no se pudo abrir en absoluto";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "La abrazadera giratoria estaba tan ajustada que el juego de transferencia no se puco cerrar en absoluto.";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "Sí, hubo daños o algo incorrecto con las roscas del ser  de transferencia que impidieron que se cierre correctamente";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "Sí, el Minicap se ha ajustado demasiado al conjunto de transferencia a mano o con una herramienta/dispositivo de asistencia";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "Parado por completo sin fluido";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "Restringido o Fluyendo parcialmente (flujo lento)";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "Sangre coagulada";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "Fibrina";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "Doblado";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "Particula";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "Material del producto";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "Exceso de yodo (marrón) identificado en el momento de la conexión o en el envase";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "Exceso de humedad (gotas transparentes) identificado en el envase";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "Empaque de foil  dañada antes de abrir ";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "Paquete/caja abierta o dañada antes de usar";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "Esponja seca y blanca";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "Esponja seca con un color marrón";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = " En el embalaje secundario/sobrebolsa";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "Dentro de la trayectoria del producto/fluido";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = " Dentro de la caja de envío";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = " En el exterior del producto";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = " En el exterior del embalaje secundario/sobrebolsa";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = " En el exterior de la caja de envío";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Dificultades para conectar el producto a otro producto";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Dificultades para desconectar el producto de otro producto";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Separación de componentes de un solo producto";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separación/desconexión del producto de otro producto";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "SI - Residous en los hilos";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "SI - Daño visible";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = " Sí - Otro (texto libre)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "Agujero para colgar";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "Puerto de  inyección/llenado";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "Puerto de membrana";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "Sobrebolsa/bolsa ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "Parche";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "Tapón de goma";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "Caja de  envío ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = " Banda encogible";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "Contenedor de solución";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = " Protector de punta";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "Sello a prueba de manipulaciones (envoltura encogible)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "Doblado";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "Roto";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "Agrietado";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "Cortado";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "Deformado";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "Descamación";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "Agujero";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "torcido";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "Derretido";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "Separación de la capa de  parche";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "Fragmentado(vidrio) ";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "Rebanado";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "Rasgado";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "La solución no fluiría en absoluto";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "La solución fluiría muy lentamente";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = " La solución no fluiría (o fluiría lentamente) durante la reconstitución o la composición";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "Botella";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "Contenedor";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "Agujero para colgar";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "Guia";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "Sobrebolsa/bolsa ";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "Indicador de oxígeno";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "Parche";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "Puertos";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "Solución";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "Protector de  punta ";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "Cámara de aminoácidos ";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "Cámara de dextrosa ";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "Cámara de  lípidos ";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "Cámara inferior";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "Cámara  superior ";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = " Reventado/Sello roto";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "Producto o pieza mal ensamblado ";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "Componente  faltante ";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "Separación/Desconexión de Componente(s) unidos ";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = " Producto Sobrellenado";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "Producto subllenado";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "roblema de  reconstitución";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = " En el embalaje secundario/sobrebolsa ";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = " Dentro de la caja de envío";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = " En el exterior de la caja de envío";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "Solución interior/Via del fluido";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = " Dentro del cárter del vaporizador (mirilla)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "En la superficie externa del producto";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = " En el exterior del embalaje secundario/sobrebolsa ";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = " En el absorbente de oxígeno";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = " En el Parche transdérmico";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = " Particulas de vidrio";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "Puerto  ";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "Tapón  de goma ";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "Tubo";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "Después de añadir otro medicamento o después de la reconstitución (viales)";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "Antes de espigar o reconstituir";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = " Frío (descongelado pero aún no a temperatura ambiente)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "Congelado";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "parcialmente descongelado (cristales de hielo en solución) ";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "Temperatura  ambiente";
translations[OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING] = "Baxter Thawing Unit (BTU)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = " Dejado en mostrador a temperatura ambiente";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "Refrigerador";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "Sí, hubo pruebas de daños durante el envío";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "Sí - se observó una fuga";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = " Sí - había un orificio o un sello incompleto en la sobrebolsa";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = " Sí - hubo dificultad para espigar o reconstituir";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = " Sí - hubo dificultad para romper lo frangible";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = " Sí - hubo cristalización o precipitación de solución";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = " Sí - hubo turbidez en el producto Frozen Galaxy";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "El producto no proporcionó el efecto previsto o fue ineficaz (falta de efecto) ";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "Efecto o reacción  no deseados. Especifique: (texto libre)";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "Caja de envío dañada durante la entrega";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Producto expirado entregado ";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "Producto expirado encontrado";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problema de código de barras - Se muestra información incorrecta cuando se escanea";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Dificultades para escanear / Código de barra no escaneable";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Producto Expirado entregado";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "Producto Expirado Encontrado en inventario ";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "Etiqueta Ilegible";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Etiqueta incorrecta";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Etiqueta  incompleta ";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = " Etiqueta demasiado similar a la de otro producto";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Las etiquetas (producto, caja/embalaje, lista de envío) no tienen la misma información del producto";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "Código de barras faltante";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "La caja contiene un producto incorrecto o un producto mixto";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "Caja de envío dañada durante la entrega";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Se recibieron unidades adicionales";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Producto expirado entregado";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Producto expirado encontrado";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "Parte de la caja se abrió o no selalda  ";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "La información del producto en la caja y la etiqueta de distribución no coincidía con el producto dentro de la caja de  cartón.  ";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "Faltaron unidades";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "Etiqueta  faltante";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "Fecha de  caducidad";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "Número de  lote ";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = "Número  NDC ";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = "Gotas o humedad dentro de la sobrebolsa sin fugas observada";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "Fuga";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "Fuga observada al apretar la bolsa";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "Solución que fluye más allá del frangible";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = " Solución dentro de la bolsa secundaria sin fugas observada";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "Entre la sobrebolsa y el contenedor primario";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "Conexión entre dos productos ";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "Contenedor - Puerto de membrana/Tubo";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "Contenedor - Puerto de inyección/llenado ";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "Contenedor - Agujero para colgar";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "Contenedor";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "Tapón de goma";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "Banda encogible";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "Protector de punta";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "Adaptador de vial";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Puerto Adherido";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "Daños (agujeros, rasgaduras) en el embalaje secundario o en la caja intermedia ";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Exposición a extremo Calor/Frio ";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Fuga en la interfaz del vaporizador";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = " Apertura de la caja de envío con un cortador de caja/objeto afilado ";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "Mascotas (desgarrados/masticados)";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Bolsa de  solución bajo presión con infuspr de presión u otro dispositivo";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "Puerto adherido";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "Daños (agujeros, rasgaduras) en el embalaje secundario o caja intermedia ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "Caja de envío  dañada durante la entrega";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Exposición al frío y calor extremo";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Fuga en la interfaz del vaporizador";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "Apertura de la caja de envío con un cortador de caja/objeto afilado";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "Mascotas (desgarrados/masticados)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Bolsa de  solución bajo presión con infuspr de presión u otro dispositivo";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Ninguno de los anteriores";
translations[NO_DESCRIBE_THE_COLOR] = "No - describe el color (texto libre)";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = "1-10 ml";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = " superior a 10 ml";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "Menos de 1 ml";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "Botella";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "Tapa";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "Válvula/Cuello";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "Ninguno";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "Dificultades para conectar el producto a otro producto";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "Dificultades para desconectar el producto de otro producto";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Separación de componentes de un solo producto";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separación/desconexión del producto de otro producto";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "Cámara de goteo";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "Tubo";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "Otro - Especifique (Texto libre)";
translations[OTHER_PLEASE_SPECIFY] = "Otro - Especifique (Texto libre)";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "Blanco/Turbio";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "Amarillo/Marrón";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = "Otro - Especifique (texto libre)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = "En el embalaje primario/bolsa blíster";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "Dentro de la vía de fluido IV (en el tubo)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Dentro de la caja de envío";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = "En el exterior de la caja de envío";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "Fuera de la vía de fluido IV (exterior de la tubería)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "Embebido";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "Suelto";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "No aplicable";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = "Describir color (texto libre)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "Sí - Cambio de color";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "Sí - Precipitado";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "Sitio de Acceso";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = "Buretas";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = "Pinza";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "Cámara de goteo";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = "Tubo";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "Desconocido";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = "Filtros";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = "Connector Luer";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "Espiga";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "Componente(s) cortados, agrietados/rotos";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "Ensamblaje de componentes  incorrecto - Especifique (texto libre)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "Componente(s) doblados/colapsados";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "Componente(s)sueltos dentro del embalaje";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "Componente(s) malformados/con forma incorrecta";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "Componente faltante";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = "Dificultad para conectar el producto a otro producto";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = "Dificultad para desconectar el producto de otro producto";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = "Conexión  suelta";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separación/desconexión del producto de otro producto";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "Separación entre dos componentes unidos en un solo producto";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = "No se pueden conectar dos productos";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = "No se puede desconectar el producto de otro producto";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problema de código de barras - Se muestra información incorrecta cuando se escanea";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "Cambio en la etiqueta";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Dificultades para escanear/  Producto de código de barras no escaneable";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "Producto Expirado";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "Información incorrecta en la etiqueta";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "Código de barras faltante /UDI";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "Información faltante en la  etiqueta en las";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "Producto sin fecha de expira";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "Manchas / Etiqueta Ilegible";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "La caja contiene un producto incorrecto o un producto mezclado";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "Caja de envío dañada durante la entrega";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Producto expirado entregado";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Producto expirado encontrado";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER] = "Baxter";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR] = "Distribuidor";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Unidades adicionales recibidas";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "Parte de la caja se abrió o no se selalda";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "La información del producto en la caja y la etiqueta de distribución no coincidía con el producto dentro de la caja de  cartón. ";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "Unidades faltantes";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "Sitio de Accesp";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "Ventilación aerea";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "Buretas";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "Tapa";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "Sitios de inyección  Clearlink";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "Pinza";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "Cámara de goteo";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "Filtros";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "Sitios de inyección interlink";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "Conector Luer";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "Espiga";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "Tubo";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = "Fuga entre sitio de inyección y tubo";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "Sitios de inyección basado en aguja";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "Sitios de inyección One-Link";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "Otros sitios de inyección (texto libre)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = " Grieta/rotura en componentes de conjunto rígido";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = " Corte/rebanada en el tubo blando";
translations[DISCONNECTION_OF_CONNECTABLE] = "Desconexión de componentes conectables y productos conectados";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Desconexión de componentes conectables y productos conectados";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "Separación de componentes unidos";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "Sí - Describir irregularidades/daños (texto libre)";
translations[YES_SPECIFY_THE_TOOL] = "Sí: especifique la herramienta utilizada (texto libre)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "Reflujo";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "Falla de pinza - Difícil de sujetar (pero eventualmente se puede cerrar)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "Falla de pinza - No se puede cerrar completamente";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "Falla de la pinza - Dificultad/No se puede de Abrir";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "Sin flujo";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "Sobreinfusión";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "Flujo Restringido/Lento";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "Flujo simultaneo";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "No posible limpiar componente";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = " No es posible purgar";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "Suninfusión";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "Sangre del  paciente (no se infunden productos sanguíneos)";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "Soluciones/Productos sanguíneos";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "Fuga Daño/Agujero";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "Desconexión";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "Fuga";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "La medicación se administraba a través de una  jeringa de infusión presurizada, o bomba DE INFUSIÓN";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "La bolsa  secundaria estaba más baja que la bolsa primaria";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "La bolsa  secundaria estaba a la misma altura que la bolsa primaria";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "Sangre Coagulada";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "el catéter no pudo enjuagarse antes de conectarseal set";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "Tubo torcido";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "Tubo/Sition de inyección bloqueado";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "Contenedor primario y secundario (piggyback)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "Dos o más cables que fluyen en un equipo de múltiples conductores";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = " Dos equipos de administración cada uno con su propia bomba de infusión";
translations[OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER] = "Baxter Hanger";
translations[OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER] = "No Baxter hanger";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "Las bolsas estaban a la misma altura";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "Primaria";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "Secundaria";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "Medio";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = "Inferior";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "Superior";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "Sí: proporcione el nombre y el código de producto de la bomba (texto libre)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "Pinza deslizante azul oscuro ";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "Pinza deslizante azul  claro ";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "Pinza de  muesca";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "Pinza de  rodillo  ";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "Pinza deslizante  blanca  ";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "Sí, la pinza estaba rota o agrietada";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "aire en línea";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "Problema de Pinza";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "olor";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "Pinza de  muesca/pinch";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "Pinza de  rodillo  ";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "Pinza deslizante";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = "Agrietado/roto";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = "Difícil de abrir";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = "Difícil de cerrar";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = "Faltante ";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "No se puede abrir";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "No se puede cerrar";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = "No se puede controlar el flujo";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = "Cámara de goteo  Difícil de apretar";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "Las instrucciones eran difíciles de seguir/entender ";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "El producto era difícil de usar";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "Grieta/ruptura";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "Corte/Rebanada";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Desconexión de componentes conectables y productos conectados";
translations[DISCONNECTION_OF_CONNECTABLE] = "Desconexión de componentes conectables y productos conectados";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "Orificio/Rasgadura";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "Separación de componentes unidos";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "Puerto adherido";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "Daños (agujeros, rasgaduras) en el embalaje secundario o caja intermedia ";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "Caja de envío  dañada durante la entrega";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "Exposición al frío y calor extremo";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "Apertura de la caja de envío con un cortador de caja/objeto afilado";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "Ninguno de los anteriores";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "Infusor o inyector de presión utilizado";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Puerto Adherido";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "Mascotas (Rasgada/masticadas)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "Producto";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = " envío";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "Dentro del producto";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = " Dentro de la caja de envío";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "En el exterior del producto";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Dificultades para conectar el producto a otro producto";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Dificultades para desconectar el producto de otro producto";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "Conexión suelta";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = " Separación de componentes de un solo producto";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = " Separación/desconexión del producto de otro producto ";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = " En el exterior de la caja de envío";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = " En el interior del embalaje secundario/sobrebolsa";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = " En el exterior del embalaje secundario/sobrebolsa";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "No fluye";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "Flujo restringido o parcial ";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problema de código de barras - Se muestra información incorrecta cuando se escanea";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Dificultades para escanear o no escaneable";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "Etiqueta ilegible  ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Etiqueta incorrecta ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Etiqueta  incompleta";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Las etiquetas (producto, caja/ambalaje, lista de envío) no tienen la misma información del producto";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "Etiqueta demasiado similar a la de otro producto ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "Etiqueta faltante ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "Código de barras faltante";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = " Se recibió el producto congelado";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = " Se recibió el producto descongelado";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "Sí, Alarma no conocida";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "Sí, especificar";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "Sí, el conjunto de transferencia no se pudo abrir completamente";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "Sí, el conjunto de transferencia no se ha podido cerrar por completo";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "Sim - La abrazadera giratoria estaba tan ajustada que el juego de transferencia no se pudo abrir en absoluto";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "Sim - La abrazadera giratoria estaba tan ajustada que el juego de transferencia no se puco cerrar en absoluto.";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "Caja o sobrebolsa";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "Pinza azil en linea de ultimo llenado";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "Cassett ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "Conector de línea de  drenaje y tapon de anillo de tirar";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "Sitio de muestra de efluentes";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "Líneas";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "Conector Luer/Espiga";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "Organizador";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "apones de anillo de tirar/protector de punta en la línea del paciente";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "Tapones de anillo de tirar/protectores de punta Conectores";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "Pinza roja en linea de calentador";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "Soldadura de Punto";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "Pinza blance en linea de suministro";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "Conector beige adaptador de catéter";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "Inserto de Chip";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "Conector azul oscuro";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "Cuerpo principal azul  claro";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "Tapon de anillo de tirar  Azul claro";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "Oclusor Azul claro";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "Tubo de  silicona";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "Espiga de titanio";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = "Espiga UV flash";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "Llave giratorio Blanca/Manga";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "Sí: Describa el daño (texto libre)";
translations[OPTION_MONTHOPTIONS_JAN] = "Ene";
translations[OPTION_MONTHOPTIONS_FEB] = "Feb";
translations[OPTION_MONTHOPTIONS_MAR] = "Mar";
translations[OPTION_MONTHOPTIONS_APR] = "Abr";
translations[OPTION_MONTHOPTIONS_MAY] = "May";
translations[OPTION_MONTHOPTIONS_JUN] = "Jun";
translations[OPTION_MONTHOPTIONS_JUL] = "Jul";
translations[OPTION_MONTHOPTIONS_AUG] = "Ago";
translations[OPTION_MONTHOPTIONS_SEP] = "Sep";
translations[OPTION_MONTHOPTIONS_OCT] = "Oct";
translations[OPTION_MONTHOPTIONS_NOV] = "Nov";
translations[OPTION_MONTHOPTIONS_DEC] = "Dic";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "Otro";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "Otro";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "Otro (Texto Libre)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "Ninguno de los anteriores";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "No";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "Sí";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "No";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "Sí";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "No";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "Sí";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "No";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "Sí";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "Preguntado desconocido";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "No";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "Desconocido";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "Sí";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "No";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "Sí";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "No";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "Sí";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "No";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "Sí";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "No";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "Sí";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "No";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "Sí";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "No";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "Sí";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "No";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "Sí";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "No";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "Sí";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "No";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "Sí";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "No";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "Sí";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "No";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "SÍ";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "No";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "Sí";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "No";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "Sí";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "No";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "No";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "Sí";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "No";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "Sí";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "No";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "Sí";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "No";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "Sí";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "No";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "Sí";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "No";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "Sí";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "No";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "Sí";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "No";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "Sí";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "No";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "Sí";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "No";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "Sí";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "No";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "No";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "Sí";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "No";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "Sí";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "No";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "Sí";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "No";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "Desconocido";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "Sí";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "No";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "Sí";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "No";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "Sí";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "No";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "Sí";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "No";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "Sí";
translations[OPTION_vaporizerSightGlassOptions_NO] = "No";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "Desconocido";
translations[OPTION_vaporizerSightGlassOptions_YES] = "Sí";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "No";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "Sí";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "No";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "Sí";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "No";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "Sí";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "No";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "Sí";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "No";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "Sí";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "No";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "Sí";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "No";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "Sí";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "No";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "Sí";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "No";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "Sí";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "No";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "Desconocido";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "Sí";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "No";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "Sí";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "No";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "Sí";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "No";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "Sí";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "No";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "Sí";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "No";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "Sí";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "No";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "Sí";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "No";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "Sí";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "No";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "Sí";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "No";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "Sí";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "Sí";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "No";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "Sí";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "No";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "Sí";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "No";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "Sí";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "No";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "Sí";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "No";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "Sí";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "No";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "Sí";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "No";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "Sí";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "No";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "Sí";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "No";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "Sí";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "No";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "Sí";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "No";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "No";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "Sí";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "No";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "No";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "Sí";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "No";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "Sí";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "No";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "Sí";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "No";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "Sí";
translations[OPTION_WITHPUMPOPTIONS_NO] = "No";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "No";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "Sí";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = " No";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "No";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "Sí";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "No";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "Sí";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "No";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "Sí";
translations[OPTION_GELPACKSOPTIONS_NO] = "No";
translations[OPTION_GELPACKSOPTIONS_YES] = "Sí";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "No";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "Sí";
translations[OPTION_ALARMOPTIONS_NO] = "No";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "No";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "Sí";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "No";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "No";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "Sí";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "No";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "Sí";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "No";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "Desconocido";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "No";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "Sí";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "Otro (Texto Libre)";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "No";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "Sí";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "No";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "Sí";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "No";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "Sí";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "Preguntado desconocido";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "Preguntado desconocido";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = " No";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = " UNK";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Ninguno de los anteriores";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "No - describe el color (texto libre)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "Sí: especifique la herramienta utilizada (texto libre)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "Separación";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "Ninguno";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = " Sí - Otro (texto libre)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = " No";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "Kilogramo(s)";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "Libra(s)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = "No";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "Desconocido";
translations[PLEASE_ENTER_THE_VALUE] = "Ingresar el valor";
translations[PLEASE_SELECT_THE_VALUE] = "Seleccione el valor";
translations[PLEASE_SELECT_THE_DATE] = "Por favor selecciones la fecha";
translations[PLEASE_CHOOSE_THE_VALUE] = "Por favor, elige el valor";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "Desconocido";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "GRAN BRETAÑA";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "KOSOVO";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "IRLANDA DEL NORTE";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "AFGANISTAN";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "ISLAS ALAND";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "ALBANIA";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "ARGELIA";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "SAMOA AMERICANA";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "ANDORRA";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "ANGOLA";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "ANGUILA";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "ANTARTICA";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "ANTIGUA Y BARBUDA";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "ARGENTINA";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "ARMENIA";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "ARUBA";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "AUSTRALIA";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "AUSTRIA";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "AZERBAIYAN";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "BAHAMAS";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "BAHRAIN";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "BANGLADESH";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "BARBADOS";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "BIELORRUSIA";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "BELGICA";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "BELICE";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "BENIN";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "BERMUDA";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "BHUTAN";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "BOLIVIA";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "BOSNIA Y HERZEGOVINA";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "BOTSWANA";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "ISLA BOUVET";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "BRASIL";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "TERRITORIO BRITANICO DEL OCEANO INDICO";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "BRUNEI DARUSSALAM";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "BULGARIA";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "BURKINA FASO";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "BURUNDI";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "CAMBOYA";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "CAMERUN";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "CANADA";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "CABO VERDE";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "ISLAS CAIMAN";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "REPUBLICA CENTROAFRICANA";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "CHAD";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "CHILE";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "CHINA";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "ISLA DE NAVIDAD";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "ISLAS COCOS (KEELING)";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "COLOMBIA";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "COMOROS";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "CONGO";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "REPUBLICA DEMOCRATICA DEL CONGO";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "ISLAS COOK";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "COSTA RICA";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "COSTA DE MARFIL";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "CROACIA";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "CUBA";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "CHIPRE";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "REPUBLICA CHECA";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "DINAMARCA";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "DJIBOUTI";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "DOMINICA";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "REPUBLICA DOMINICANA";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "ECUADOR";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "EGIPTO";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "EL SALVADOR";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "GUINEA ECUATORIAL";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "ERITREA";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "ESTONIA";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "ETIOPIA";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "ISLAS MALVINAS";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "ISLAS FAROE";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "FIJI";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "FINLANDIA";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "FRANCIA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "GUAYANA FRANCESA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "POLINESIA FRANCESA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "TERRITORIOS FRANCESES DEL SUR";
translations[OPTION_COUNTRYOPTIONS_GABON] = "GABON";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "GAMBIA";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "GEORGIA";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "ALEMANIA";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "GHANA";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "GIBRALTAR";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "GRECIA";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "GROENLANDIA";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "GRANADA";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "GUADALUPE";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "GUAM";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "GUATEMALA";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "GUERNSEY";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "GUINEA";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "GUINEA-BISSAU";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "GUYANA";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "HAITI";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "ISLA HEARD E ISLAS  MCDONALD";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "CIUDAD DEL VATICANO";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "HONDURAS";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "HONG KONG";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "HINGRIA";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "ISLANDIA";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "INDIA";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "INDONESIA";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "IRAN";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "IRAQ";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "IRLANDA";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "ISLA DE MAN";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "ISRAEL";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "ITALIA";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "JAMAICA";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "JAPON";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "JERSEY";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "JORDANIA";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "KAZAJISTAN";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "KENIA";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "KIRIBATI";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "COREA DEL NORTE";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "REPUBLICA DE COREA";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "KUWAIT";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "KIRGUISTAN";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "LAOS";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "LETONIA";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "LIBANO";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "LESOTO";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "LIBERIA";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "LIBIA";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "LIECHTENSTEIN";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "LITUANIA";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "LUXEMBURGO";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "MACAO";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "MACEDONIA";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "MADAGASCAR";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "MALAWI";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "MALASIA";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "MALDIVAS";
translations[OPTION_COUNTRYOPTIONS_MALI] = "MALI";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "MALTA";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "ISLAS MARSHALL";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "MARTINICA";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "MAURITANIA";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "MAURICIO";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "MAYOTTE";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "MEXICO";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "MICRONESIA";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "MOLDAVIA";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "MONACO";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "MONGOLIA";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "MONTENEGRO";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "MONTSERRAT";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "MARRUECOS";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "MOZAMBIQUE";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "MYANMAR";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "NAMIBIA";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "NAURU";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "NEPAL";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "PAISES BAJOS";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "NUEVA CALEDONIA";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "NUEVA ZELANDA";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "NICARAGUA";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "NIGER";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "NIGERIA";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "NIUE";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "ISLA NORFOLK";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "ISLAS MARIANAS DEL NORTE";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "NORUEGA";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "OMAN";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "PAKISTAN";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "PALAU";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "PALESTINA";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "PANAMA";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "PAPUA NUEVA GUINEA";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "PARAGUAY";
translations[OPTION_COUNTRYOPTIONS_PERU] = "PERU";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "FILIPINAS";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "PITCAIRN";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "POLONIA";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "PORTUGAL";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "PUERTO RICO";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "QATAR";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "RÉUNION";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "RUMANIA";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "FEDERACION RUSA";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "RUANDA";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "SAN BARTOLOME";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "SANTA HELENA";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "SAN CRISTOBAL Y NIEVES";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "SANTA LUCIA";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "SAN MARTIN";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "SAN PEDRO Y MIQUELON";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "SAN VICENTE Y LAS GRANADINAS";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "SAMOA";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "SAN MARINO";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "SANTO TOME Y PRINCIPE";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "ARABIA SAUDITA";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "SENEGAL";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "SERBIA";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "SEYCHELLES";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "SIERRA LEONSA";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "SINGAPUR";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "ESLOVAQUIA";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "ESLOVENIA";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "ISLAS SALOMON";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "SOMALIA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "SUDAFRICA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "ISLAS GEORGIAS DEL SUR Y SANDWICH DEL SUR";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "ESPAÑA";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "SRI LANKA";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "SUDAN";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "SURINAM";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "SVALBARD Y JAN MAYEN";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "SUAZILANDIA";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "SUECIA";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "SUIZA";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "SIRIA";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "TAIWAN, R.O.C.";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "TAYIKISTAN";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "TANZANIA";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "TAILANDIA";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "TIMOR-LESTE";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "TOGO";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "TOKELAU";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "TONGA";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "TRINIDAD Y TOBAGO";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "TUNEZ";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "TURQUIA";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "TURKMENISTAN";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "ISLAS TURCAS Y CAICOS";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "TUVALU";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "UGANDA";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "UCRANIA";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "EMIRATOS ARABES UNIDOS";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "REINO UNIDO";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "ESTADOS UNIDOS";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "ISLAS ULTRAMARINAS MENORES DE ESTADOS UNIDOS";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "URUGUAY";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "UZBEKISTAN";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "VANUATU";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "VENEZUELA";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "VIET NAM";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "ISLAS VIRGENES BRITANICAS";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "ISLAS VIRGENES DE LOS ESTADOS UNIDOS";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "WALLIS Y FUTUNA";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "REPUBLICA ARABE SAHARAUI DEMOCRATICA";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "YEMEN";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "ZAMBIA";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "ZIMBAUE";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "No";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "Desconocido";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "Sí";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "He leído y entiendo el Aviso de privacidad vinculado al portal de comentarios sobre productos de Baxter. ";
translations[PRODUCT_LOT] = "Lote de producto";
translations[SHIPPING_DISTRIBUTION_LABEL] = "Etiqueta de envío/distribución";
translations[CARTON_LABEL] = "Etiqueta de cartón";
translations[INTERNAL_PRODUCT_LABEL] = "Etiqueta interna del producto";
translations[TITLE_PD_RENAL] = "EP renal";
translations[TITLE_SOLUTIONS] = "Soluciones";
translations[TITLE_ACCESS] = "Acceso";
translations[TITLE_ALL_OTHER_PRODUCT] = "Todos los demás productos";
translations[REPORTED_PROBLEM] = "Problema reportado";
translations[LOGIN] = "Acceso";
translations[SYSTEM_MENU] = "Menu del sistema";
translations[INITIATE_PRODUCT_FEEDBACK] = "Iniciar retroalimentación sobre producto";
translations[FEEDBACK_STATUS] = "Estado de comentarios";
translations[OKTACALLBACK] = "OktaCallback";
translations[VALID_EMAIL] = "Ingresar una dirección de correo electrónico válida";
translations[VALID_NUMERIC] = "Ingresar número";
translations[PLEASE_UPLOAD_IMAGE] = "Subir imágenes";
translations[VALID_DATE] = "por favor seleccione una fecha valida";
translations[QUANTITY] = "Cantidad";
translations[EDIT] = "Editar";
translations[DELETE] = "Borrar";
translations[LOT_SERIAL_NO] = "Número de lote/serie";
translations[LOT_NUMBER_NOT_FOUND] = "Numero de lote no encontrado";
translations[SEARCHING_LOT_NUMBER] = "Buscar Numero de lote";
translations[PRODUCT_CODE_NOT_FOUND] = "Codigo de producto no encontrado";
translations[SEARCHING_PRODUCT_CODE] = "Buscar codigo de producto";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "Tipo de archivo (.asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps) no son permitidos";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "El archivo qu esta tratando de adjuntar excede el limite permitido. Por favor comprimalo o adjunte un archivo diferente.";
translations[IMAGE_ICON] = "Haga click en la imagen para seleccionar la opción";
translations[LOGIN_TO_ACCOUNT] = "Iniciar sesión en la cuenta";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "Iniciar sesión en su cuenta";
translations[BAXTER_EMAIL_ADDRESS] = "Dirección de correo electrónico de Baxter";
translations[PASSWORD] = "Clave";
translations[SIGN_IN] = "Registrarse";
translations[UNKNOWN] = "Desconocido";
translations[ASKED_UNKNOWN] = "Preguntado desconocido";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "Seleccionar país";
translations[CHINESE_SIMPLIFIED_CHINESE] = "Chino (Chino Simplificado)";
translations[DUTCH] = "Holandés";
translations[ENGLISH] = "Inglés";
translations[FRENCH] = "Francés";
translations[GERMAN] = "Alemán";
translations[ITALIAN] = "Italiano";
translations[JAPANESE] = "Japonés";
translations[KOREAN] = "Coreano";
translations[MANDARIN_TRADITIONAL_CHINESE] = "Mandarín (Chino Tradicional)";
translations[POLISH] = "Polaco";
translations[PORTUGUESE] = "Portugués";
translations[SPANISH] = "Español";
translations[THAI] = "Tailandés";
translations[TURKISH] = "Turco";
translations[VIETNAMESE] = "Vietnamita";
translations[BROWSE] = "Navegar";
translations[FEEDBACK_SUBMITTED] = "Comentarios enviados";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "La retroalimentación  del producto se ha enviado correctamente. Gracias por su  reporte. Recibirá un correo electrónico con un número de referencia. Como proveedor de productos médicos, la satisfacción del cliente y la retroalimentación de nuestros productos son esenciales para nuestro objetivo de proporcionar productos de la más alta calidad. Por favor contactar";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "si tiene preguntas o información adicional.";
translations[CLOSE] = "Cerrar";
translations[PATIENT_AGE] = "Edad del paciente";
translations[ENTER_AGE] = "Ingrese la edad";
translations[PATIENT_DOB] = "Fecha de Nacimiento del paciente";
translations[RELEVANT_ATTACHMENTS] = "Proporcione los anexos pertinentes";
translations[BAXTER_ACCOUNT_CREDENTIALS] = "Ingresar las credenciales de su cuenta de Baxter";
translations[GET_PRODUCT_DETAILS] = "Obtener detalles del producto";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "Use el diagrama anterior (figura 2) para determinar la ubicación del problema informado";
translations[FACILITY_ADDRESS] = "Dirección de la institución";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "Otra dirección de la institución";
translations[CHOOSE_PRODUCT_CODE] = "Por favor seleccione el código de producto para el lote/serie ingresado";
translations[DECLINE] = "Rechazar";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "BONAIRE, SAN EUSTAQUIO Y SABA";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "CURAZAO";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "SUDÁN DEL SUR";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "ESWATINI";
translations[FORM_HELP_TEXT] = "indica que hay texto de ayuda disponible para este campo";
translations[YOUR_FIRST_NAME] = "Su nombre";
translations[YOUR_LAST_NAME] = "Su apellido";
translations[MY_FIRST_NAME] = "Mi primer nombre";
translations[MY_LAST_NAME] = "Mi apellido";
translations[PATIENT_FIRST_NAME] = "Nombre del paciente";
translations[PATIENT_LAST_NAME] = "Apellido del paciente";
translations[REPORTER_FIRST_NAME] = "Nombre de quien reporta";
translations[REPORTER_LAST_NAME] = "Apellido de quien reporta";
translations[EMPLOYEE_FIRST_NAME] = "Nombre del empleado";
translations[EMPLOYEE_LAST_NAME] = "Apellido del empleado";
translations[END_USER_CUSTOMER_FIRST_NAME] = "Nombre del contacto del usuario final/cliente";
translations[END_USER_CUSTOMER_LAST_NAME] = "Apellido del contacto del usuario final/cliente";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "Nombre de contacto adicional";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "Apellido de contacto adicional";
translations[COPYRIGHT] = "Copyright ©";
translations[COPYRIGHT_BAXTER] = "Baxter";
translations[COPYRIGHT_VERSION] = "Todos los derechos reservados | Versión";
translations[ADD_ADDITIONAL_CONTACT] = "Agregar contacto adicional";
translations[CONTACT_ME] = "El cliente no desea ser contactado. Póngase en contacto conmigo para cualquier pregunta adicional.";
translations[DO_NOT_CONTACT] = "No contactar";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "Nombre de la organización del usuario final/cliente";
translations[END_USER_CUSTOMER_PHONE] = "Número de teléfono de la organización del usuario final/cliente";
translations[END_USER_CUSTOMER_EMAIL] = "Dirección de correo electrónico del usuario final/cliente";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "Dirección de la organización del usuario final/cliente";
translations[SAME_AS_PATIENT_ADDRESS] = "La misma que dirección del paciente";
translations[SAME_AS_REPORTER_ADDRESS] = "La misma que dirección del reportante";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "La misma que dirección de la organización del usuario final/cliente";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "Utilice el diagrama anterior (figura 3) para determinar la ubicación del problema reportado";
translations[CONTACT_US] = "Contacta con nosotros";
translations[LANDING_BRIEF_FOR_DEVICE] = "Para reparación de equipos, piezas, servicios o soporte técnico, por favor contacte al equipo local de servicio.";
translations[PATIENT_SEX] = "Sexo del Paciente";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "Hombre/niño cisgénero";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "Mujer/niña cisgénero";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "Hombre transgénero/hombre trans/mujer a hombre";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "Mujer transgénero/mujer trans/hombre a mujer";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "Otra categoría de género; Por favor especifica";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "Se niega a contestar";
translations[ATTENTION_NEEDED] = "!!! SE NECESITA ATENCIÓN URGENTE: ¡SU ENVÍO AL PORTAL DE COMENTARIOS SOBRE PRODUCTOS HA FALLADO!";
translations[SUBMIT_ERR_MSG] = "Para volver a enviarla, haz clic en Aceptar y, a continuación, en Enviar o envía tu queja por correo electrónico a (@@@).";
translations[SUBMIT_RETRY_MSG] = "Si lo has vuelto a enviar, comprueba que has recibido un correo electrónico de confirmación en tu casilla de correo electrónico desde el portal de comentarios sobre productos. Si no has recibido ningún correo electrónico de confirmación, significa que el envío no se ha realizado correctamente y DEBES enviar tu queja por correo electrónico a (@@@).";
translations[OK] = "OK";

export default lang;